import React, {
useEffect,
useMemo,
useRef,
useState
} from 'react';

import {
useDispatch,
useSelector
} from 'react-redux';

import Swal from 'sweetalert2';

import useConfigAuth from '../../../Hooks/useConfigAuth.js';
import CentroModal from './CentroModal.js';
import VincularPacienteCentroModal from './VincularPacienteCentroModal.js';
import CondicionesPacienteCentroModal from './CondicionesPacienteCentroModal.js';
import ConfiguracionCentroModal from './ConfiguracionCentroModal.js';
import PagoCentroModal from './PagoCentroModal.js';
import HistorialPagosCentroModal from './HistorialPagosCentroModal.js';

import {
cargarCentrosAction,
cargarResumenCentrosAction,
cargarLiquidacionCentroAction,
crearCentroAction,
cargarAcuerdosCentroAction,
crearAcuerdoCentroAction,
actualizarAcuerdoCentroAction,
cerrarAcuerdoCentroAction,
cargarConfiguracionesCentroAction,
crearConfiguracionCentroAction,
registrarPagoCentroAction,
cargarPagosCentroAction,
anularPagoCentroAction,
cambiarPagarPrestacionCentroAction
} from '../../../actions/centrosLiquidacionesActions.js';

import {
EstadisticasMain,

ContenedorFiltros,
GrupoPeriodos,
BotonPeriodo,
PeriodoTexto,

FechasPersonalizadas,
FechaPersonalizadaGrupo,
FechaPersonalizadaLabel,
FechaPersonalizadaInput,

GridKpis,
TarjetaKpi,
KpiTitulo,
KpiValor,
KpiDetalle,

SeccionTitulo,
SeccionTituloPrincipal,
SeccionTituloSecundario,

TablaContenedor,
TablaTurnos,

CobroSelect,

Importe,
EstadoBadge,

SinInformacion,
CargandoEstadisticas,
BotonPrincipal,
BotonSecundario
} from '../../Css/StyledEstadisticasCobros.js';


/*
====================================
FECHA LOCAL
====================================
*/

const formatDateLocal = (date) => {

const year =
date.getFullYear();

const month =
String(
date.getMonth() + 1
).padStart(
2,
'0'
);

const day =
String(
date.getDate()
).padStart(
2,
'0'
);


return `${year}-${month}-${day}`;

};


/*
====================================
FECHA PARA MOSTRAR
====================================
*/

const formatDateDisplay = (value) => {

if (!value) {

return '—';

}


const [
year,
month,
day
] = String(value)
.substring(
0,
10
)
.split('-');


if (
!year ||
!month ||
!day
) {

return value;

}


return `${day}/${month}/${year}`;

};


/*
====================================
DINERO
====================================
*/

const formatMoney = (value) => {

return new Intl.NumberFormat(
'es-AR',
{
style:
'currency',

currency:
'ARS',

maximumFractionDigits:
0
}
).format(
Number(value || 0)
);

};


/*
====================================
MES YYYY-MM
====================================
*/

const formatMonth = (date) => {

const year =
date.getFullYear();

const month =
String(
date.getMonth() + 1
).padStart(
2,
'0'
);


return `${year}-${month}`;

};


/*
====================================
MES ACTUAL
====================================
*/

const getCurrentMonth = () => {

return formatMonth(
new Date()
);

};


/*
====================================
MES ANTERIOR
====================================
*/

const getPreviousMonth = () => {

const now =
new Date();


return formatMonth(
new Date(
now.getFullYear(),
now.getMonth() - 1,
1
)
);

};


/*
====================================
AÑO ACTUAL
====================================
*/

const getCurrentYearPeriod = () => {

const now =
new Date();


return {

fecha_desde:
formatDateLocal(
new Date(
now.getFullYear(),
0,
1
)
),

fecha_hasta:
formatDateLocal(
new Date(
now.getFullYear(),
11,
31
)
)

};

};


/*
====================================
LABEL FEE
====================================
*/

const getFeeLabel = (prestacion) => {

switch (
prestacion?.fee_tipo
) {

case 'PORCENTAJE':

return `${Number(
prestacion.fee_valor || 0
)}%`;


case 'FIJO_PRESTACION':

return `${formatMoney(
prestacion.fee_valor
)} por prestación`;


case 'FIJO_MENSUAL':

return `${formatMoney(
prestacion.fee_valor
)} mensual`;


default:

return '—';

}

};


/*
====================================
TIPO DE PRESTACIÓN
====================================
*/

const getTipoPrestacionLabel = (
tipo
) => {

switch (
tipo
) {

case 'SESION_PACIENTE':

return 'Sesión';


case 'REUNION_PADRES':

return 'Reunión padres';


case 'REUNION_COLEGIO':

return 'Reunión colegio';


case 'REUNION_PROFESIONALES':

return 'Reunión profesionales';


default:

return tipo || '—';

}

};

/*
====================================
ACUERDO CON CONDICIONES PARTICULARES
====================================
*/

const acuerdoTieneOverrides = (
acuerdo
) => {

if (
!acuerdo
) {

return false;

}


const campos = [

'fee_tipo_override',
'fee_valor_override',
'fee_base_override',
'fee_mensual_condicion_override',

'paga_sesion_paciente_override',
'paga_reunion_padres_override',
'paga_reunion_colegio_override',
'paga_reunion_profesionales_override',

'vencimiento_tipo_override',
'vencimiento_meses_override',
'vencimiento_dia_override'

];


return campos.some(
(campo) =>

acuerdo[campo] !==
null &&

acuerdo[campo] !==
undefined
);

};


/*
====================================
TIPO DE CONDICIÓN DEL PACIENTE
====================================
*/

const getTipoCondicionPaciente = (
acuerdos
) => {

if (
!Array.isArray(
acuerdos
) ||
acuerdos.length ===
0
) {

return {
tipo:
'SIN_VINCULO',

texto:
'Sin vínculo'
};

}


const particulares =
acuerdos.filter(
acuerdoTieneOverrides
).length;


if (
particulares ===
0
) {

return {
tipo:
'GENERAL',

texto:
'General'
};

}


if (
particulares ===
acuerdos.length
) {

return {
tipo:
'PARTICULAR',

texto:
'Particular'
};

}


return {
tipo:
'MIXTA',

texto:
'Mixta'
};

};

/*
====================================
COMPONENTE
====================================
*/

const CentrosLiquidaciones = ({

refrescoVersion = 0

}) => {

const dispatch =
useDispatch();


const [config] =
useConfigAuth();


/*
====================================
PACIENTE DEL MÓDULO CENTROS
====================================

Es independiente del paciente elegido
en Estadísticas de pacientes.

Siempre comienza mostrando todos.
====================================
*/

const [
idPacienteSeleccionadoCentro,
setIdPacienteSeleccionadoCentro
] = useState(
'TODOS'
);


const idPacienteFiltro =

idPacienteSeleccionadoCentro !==
'TODOS'

? idPacienteSeleccionadoCentro

: null;


/*
====================================
REDUX
====================================
*/

const centrosRedux =
useSelector(
(state) =>
state.centrosLiquidaciones ||
{}
);


const centros =
Array.isArray(
centrosRedux.centros
)

? centrosRedux.centros

: [];


const resumenCentros =
Array.isArray(
centrosRedux.resumenCentros
)

? centrosRedux.resumenCentros

: [];


const cargandoCentros =
Boolean(
centrosRedux.cargandoCentros
);


const cargandoResumen =
Boolean(
centrosRedux.cargandoResumen
);

const acuerdosCentro =
Array.isArray(
centrosRedux.acuerdosCentro
)

? centrosRedux.acuerdosCentro

: [];


const cargandoAcuerdosCentro =
Boolean(
centrosRedux.cargandoAcuerdosCentro
);


const guardandoAcuerdoCentro =
Boolean(
centrosRedux.guardandoAcuerdoCentro
);

const guardandoCondicionesAcuerdoCentro =
Boolean(
centrosRedux
.guardandoCondicionesAcuerdoCentro
);

const cerrandoAcuerdoCentro =
Boolean(
centrosRedux
.cerrandoAcuerdoCentro
);

const configuracionesCentro =
Array.isArray(
centrosRedux
.configuracionesCentro
)

? centrosRedux
.configuracionesCentro

: [];


const cargandoConfiguracionesCentro =
Boolean(
centrosRedux
.cargandoConfiguracionesCentro
);


const guardandoConfiguracionCentro =
Boolean(
centrosRedux
.guardandoConfiguracionCentro
);

const posicionCentro =
centrosRedux
.posicionCentro ||
null;


const cargandoPosicionCentro =
Boolean(
centrosRedux
.cargandoPosicionCentro
);


const registrandoPagoCentro =
Boolean(
centrosRedux
.registrandoPagoCentro
);

const pagosCentro =
Array.isArray(
centrosRedux
.pagosCentro
)

? centrosRedux
.pagosCentro

: [];


const cargandoPagosCentro =
Boolean(
centrosRedux
.cargandoPagosCentro
);


const anulandoPagoCentro =
Boolean(
centrosRedux
.anulandoPagoCentro
);

const guardandoCondicionPrestacionCentro =
Boolean(
centrosRedux
.guardandoCondicionPrestacionCentro
);

/*
====================================
PACIENTES
====================================
*/

const pacientes =
useSelector(
(state) =>
state.informacion
?.lista_pacientes ||
[]
);


/*
====================================
CENTRO SELECCIONADO
====================================
*/

const [
centroSeleccionadoId,
setCentroSeleccionadoId
] = useState('');

/*
====================================
¿EL HISTORIAL YA ESTÁ CARGADO?
====================================
*/

const clavePagosCentroSeleccionado =

centroSeleccionadoId

? `${String(
centroSeleccionadoId
)}|ARS`

: null;


const historialPagosCentroCargado =

Boolean(
clavePagosCentroSeleccionado
) &&

Object.prototype
.hasOwnProperty
.call(

centrosRedux
.pagosCentroCache ||
{},

clavePagosCentroSeleccionado

);

/*
====================================
PERÍODO
====================================
*/

const [
tipoPeriodo,
setTipoPeriodo
] = useState(
'MES_ACTUAL'
);


const [
fechaDesdePersonalizada,
setFechaDesdePersonalizada
] = useState('');


const [
fechaHastaPersonalizada,
setFechaHastaPersonalizada
] = useState('');


/*
====================================
MODAL CENTRO
====================================
*/

const [
modalCentroAbierto,
setModalCentroAbierto
] = useState(
false
);


const [
guardandoCentro,
setGuardandoCentro
] = useState(
false
);

/*
====================================
MODAL VINCULAR PACIENTE
====================================
*/

const [
modalVincularPacienteAbierto,
setModalVincularPacienteAbierto
] = useState(
false
);

/*
====================================
MODAL CONDICIONES DEL PACIENTE
====================================
*/

const [
modalCondicionesPacienteAbierto,
setModalCondicionesPacienteAbierto
] = useState(
false
);


const [
pacienteCondicionesSeleccionado,
setPacienteCondicionesSeleccionado
] = useState(
null
);

const [
modalConfiguracionCentroAbierto,
setModalConfiguracionCentroAbierto
] = useState(
false
);

const [
modalPagoCentroAbierto,
setModalPagoCentroAbierto
] = useState(
false
);

const [
modalHistorialPagosCentroAbierto,
setModalHistorialPagosCentroAbierto
] = useState(
false
);

/*
====================================
PACIENTES DESPLEGADOS
====================================
*/

const [
pacientesDesplegados,
setPacientesDesplegados
] = useState(
[]
);


/*
====================================
TOKEN
====================================
*/

const authToken =
config?.headers?.Authorization ||
config?.headers?.authorization ||
null;

/*
====================================
CENTRO SELECCIONADO
====================================
*/

const centroSeleccionado =
useMemo(() => {

return (
centros.find(
(centro) =>
String(
centro.id
) ===
String(
centroSeleccionadoId
)
) ||
null
);

}, [
centros,
centroSeleccionadoId
]);


/*
====================================
LIQUIDACIÓN DETALLADA DEL CENTRO
====================================

El resumen general y la liquidación
detallada ahora son dos datos distintos.

resumenCentros:
una sola consulta liviana para todos.

liquidacion:
detalle completo únicamente del centro
que estamos viendo.
====================================
*/

const liquidacion =
    useMemo(() => {

        const actual =
            centrosRedux
                ?.liquidacion ||
            null;


        if (
            !actual ||
            !centroSeleccionadoId
        ) {

            return null;

        }


        /*
        Evitamos mostrar durante un render
        la liquidación del centro anterior
        mientras cambia la selección.
        */

        if (
            String(
                actual.centro_id
            ) !==
            String(
                centroSeleccionadoId
            )
        ) {

            return null;

        }


        return actual;

    }, [
        centrosRedux.liquidacion,
        centroSeleccionadoId
    ]);


/*
====================================
MAPA DE PACIENTES
====================================
*/

const pacientesPorId =
useMemo(() => {

const mapa =
new Map();


pacientes.forEach(
(paciente) => {

mapa.set(
String(
paciente.id_paciente
),
paciente
);

}
);


return mapa;

}, [
pacientes
]);


/*
====================================
NOMBRE DEL PACIENTE
====================================
*/

const getNombrePaciente = (
idPaciente
) => {

const paciente =
pacientesPorId.get(
String(
idPaciente
)
);


if (
!paciente
) {

return 'Paciente';

}


return `${paciente.apellido || ''}, ${paciente.nombre || ''}`
.replace(
/^,\s*/,
''
)
.trim();

};


/*
====================================
PERÍODO
====================================
*/

const periodoConsulta =
useMemo(() => {

switch (
tipoPeriodo
) {

case 'MES_ANTERIOR':

return {
mes:
getPreviousMonth()
};


case 'ANIO_ACTUAL':

return getCurrentYearPeriod();


case 'PERSONALIZADO':

return {

fecha_desde:
fechaDesdePersonalizada,

fecha_hasta:
fechaHastaPersonalizada

};


case 'MES_ACTUAL':

default:

return {
mes:
getCurrentMonth()
};

}

}, [
tipoPeriodo,
fechaDesdePersonalizada,
fechaHastaPersonalizada
]);


/*
====================================
PERÍODO VÁLIDO
====================================
*/

const periodoValido =
useMemo(() => {

if (
tipoPeriodo !==
'PERSONALIZADO'
) {

return true;

}


if (
!fechaDesdePersonalizada ||
!fechaHastaPersonalizada
) {

return false;

}


return (
fechaDesdePersonalizada <=
fechaHastaPersonalizada
);

}, [
tipoPeriodo,
fechaDesdePersonalizada,
fechaHastaPersonalizada
]);


/*
====================================
TEXTO DEL PERÍODO
====================================
*/

const periodoTexto =
useMemo(() => {

if (
tipoPeriodo ===
'MES_ACTUAL'
) {

return getCurrentMonth();

}


if (
tipoPeriodo ===
'MES_ANTERIOR'
) {

return getPreviousMonth();

}


if (
tipoPeriodo ===
'ANIO_ACTUAL'
) {

const periodo =
getCurrentYearPeriod();


return `${formatDateDisplay(
periodo.fecha_desde
)} — ${formatDateDisplay(
periodo.fecha_hasta
)}`;

}


if (
!fechaDesdePersonalizada ||
!fechaHastaPersonalizada
) {

return 'Seleccioná el período';

}


return `${formatDateDisplay(
fechaDesdePersonalizada
)} — ${formatDateDisplay(
fechaHastaPersonalizada
)}`;

}, [
tipoPeriodo,
fechaDesdePersonalizada,
fechaHastaPersonalizada
]);


/*
====================================
CARGAR CENTROS
====================================

La action revisa la caché.

Si los centros ya están cargados,
no vuelve a pedirlos.
====================================
*/

useEffect(() => {

if (
!authToken ||
!config
) {

return;

}


const cargar =
async () => {

try {

await dispatch(
cargarCentrosAction({
config
})
);


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

'No se pudieron cargar los centros.';


await Swal.fire({

icon:
'error',

title:
'No se pudieron cargar los centros',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};


cargar();

}, [
authToken,
dispatch
]);


/*
====================================
PRIMER CENTRO
====================================
*/

useEffect(() => {

if (
centroSeleccionadoId ||
centros.length === 0
) {

return;

}


const centroActivo =
centros.find(
(centro) =>
centro.activo !== false
);


const centroInicial =
centroActivo ||
centros[0];


if (
centroInicial?.id
) {

setCentroSeleccionadoId(
String(
centroInicial.id
)
);

}

}, [
centros,
centroSeleccionadoId
]);

/*
====================================
CARGAR PACIENTES VINCULADOS
====================================

Cada centro se consulta una sola vez.

Cambiar de centro utiliza la caché
cuando ya fue consultado.
====================================
*/

useEffect(() => {

if (
!authToken ||
!config ||
!centroSeleccionadoId
) {

return;

}


const cargar =
async () => {

try {

await dispatch(
cargarAcuerdosCentroAction({

config,

centro_id:
centroSeleccionadoId

})
);


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

'No se pudieron cargar los pacientes vinculados al centro.';


await Swal.fire({

icon:
'error',

title:
'No se pudieron cargar los pacientes',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};


cargar();

}, [
authToken,
dispatch,
centroSeleccionadoId
]);

/*
====================================
CARGAR INFORMACIÓN ECONÓMICA
====================================

La action maneja la caché.

El centro seleccionado NO forma parte
de las dependencias porque cambiar de
centro utiliza la información que ya
está cargada.
====================================
*/

useEffect(() => {

if (
!authToken ||
!config ||
centros.length === 0 ||
!periodoValido
) {

return;

}


const cargar =
async () => {

try {

await dispatch(
cargarResumenCentrosAction({

config,

centros,

id_paciente:
idPacienteFiltro,

mes:
periodoConsulta.mes ||
null,

fecha_desde:
periodoConsulta.fecha_desde ||
null,

fecha_hasta:
periodoConsulta.fecha_hasta ||
null,

moneda:
'ARS'

})
);


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

'No se pudo cargar la información de los centros.';


await Swal.fire({

icon:
'error',

title:
'No se pudo cargar la información',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};


cargar();

}, [
authToken,
dispatch,
centros,
idPacienteFiltro,
periodoConsulta,
periodoValido
]);

/*
====================================
CARGAR DETALLE DEL CENTRO VISIBLE
====================================

El resumen general se carga con una
sola request para todos los centros.

El detalle completo se consulta
solamente para el centro seleccionado.

Cada combinación:

- centro;
- paciente;
- período;

se fuerza como máximo una vez por cada
entrada a la solapa Centros.

Si el usuario cambia de centro y vuelve
al mismo durante esa entrada, usamos caché.

Cuando vuelve desde Pacientes,
refrescoVersion cambia y el detalle
vuelve a consultarse una sola vez.
====================================
*/

/*
====================================
CONTROL DEL DETALLE DEL CENTRO
====================================

detalleRefrescadoVersionRef:
recuerda qué combinación ya fue
refrescada contra backend durante
cada entrada a Centros.

ultimoDetalleProcesadoRef:
evita que un nuevo render vuelva a
disparar exactamente la misma carga.

Esto es especialmente importante
porque Redux y config pueden provocar
nuevos renders mientras una request
todavía está en curso.
====================================
*/

const detalleRefrescadoVersionRef =
    useRef({});


const ultimoDetalleProcesadoRef =
    useRef(
        null
    );


useEffect(() => {

    if (
        !authToken ||
        !config ||
        !centroSeleccionadoId ||
        !periodoValido
    ) {

        return;

    }


    const claveDetalleVisible = [

        String(
            centroSeleccionadoId
        ),

        String(
            idPacienteFiltro ||
            'TODOS'
        ),

        String(
            periodoConsulta
                ?.mes ||
            ''
        ),

        String(
            periodoConsulta
                ?.fecha_desde ||
            ''
        ),

        String(
            periodoConsulta
                ?.fecha_hasta ||
            ''
        )

    ].join('|');


    /*
    ====================================
    FIRMA DE ESTA EJECUCIÓN
    ====================================

    Incluye refrescoVersion.

    Entonces:

    - renders del mismo centro → NO repiten;
    - cambiar de centro → procesa;
    - cambiar período → procesa;
    - cambiar paciente → procesa;
    - volver desde Pacientes → procesa.
    ====================================
    */

    const firmaEjecucion =
        `${refrescoVersion}|${claveDetalleVisible}`;


    /*
    ====================================
    YA PROCESAMOS ESTA MISMA EJECUCIÓN
    ====================================

    Éste es el corte que evita la
    catarata de requests.
    ====================================
    */

    if (
        ultimoDetalleProcesadoRef
            .current ===
        firmaEjecucion
    ) {

        return;

    }


    ultimoDetalleProcesadoRef
        .current =
        firmaEjecucion;


    /*
    ====================================
    ¿HAY QUE FORZAR BACKEND?
    ====================================
    */

    const versionYaRefrescada =

        detalleRefrescadoVersionRef
            .current[
                claveDetalleVisible
            ];


    const debeForzar =

        versionYaRefrescada !==
        refrescoVersion;


    /*
    La marcamos antes del dispatch.

    Si Redux provoca un render mientras
    la request está pendiente, el bloque
    anterior corta la repetición.
    */

    detalleRefrescadoVersionRef
        .current[
            claveDetalleVisible
        ] =
        refrescoVersion;


    dispatch(
        cargarLiquidacionCentroAction({

            config,

            centro_id:
                centroSeleccionadoId,

            id_paciente:
                idPacienteFiltro,

            mes:
                periodoConsulta
                    .mes ||
                null,

            fecha_desde:
                periodoConsulta
                    .fecha_desde ||
                null,

            fecha_hasta:
                periodoConsulta
                    .fecha_hasta ||
                null,

            moneda:
                'ARS',

            incluir_detalle:
                true,

            forzar:
                debeForzar

        })
    )
        .catch(
            () => {

                /*
                Si falló la consulta,
                habilitamos un nuevo intento.
                */

                if (
                    ultimoDetalleProcesadoRef
                        .current ===
                    firmaEjecucion
                ) {

                    ultimoDetalleProcesadoRef
                        .current =
                        null;

                }


                if (
                    detalleRefrescadoVersionRef
                        .current[
                            claveDetalleVisible
                        ] ===
                    refrescoVersion
                ) {

                    delete detalleRefrescadoVersionRef
                        .current[
                            claveDetalleVisible
                        ];

                }

            }
        );

}, [
    authToken,
    config,
    dispatch,
    centroSeleccionadoId,
    idPacienteFiltro,
    periodoConsulta,
    periodoValido,
    refrescoVersion
]);

/*
====================================
REFRESCAR AL VOLVER A CENTROS
====================================

Cuando volvemos desde Pacientes pudo
haber cambiado:

- una prestación;
- un cobro;
- una obligación;
- una imputación.

Hacemos únicamente:

1. UNA request masiva para refrescar
   el resumen de todos los centros.

2. El detalle del centro visible se
   ocupa de refrescarlo el useEffect
   anterior.

3. El historial se refresca solamente
   si el usuario ya lo había abierto.

No solicitamos posición por separado:
viene dentro de la liquidación detallada.
====================================
*/


/*
====================================
¿HABÍA RESUMEN AL MONTAR?
====================================

Evita duplicar la request en la primera
entrada al módulo.

Si todavía no había resumen, la carga
inicial normal ya se encarga.
====================================
*/

const habiaResumenAlMontarRef =
    useRef(

        Boolean(

            centrosRedux
                ?.resumenActualKey ||

            (
                Array.isArray(
                    centrosRedux
                        ?.resumenCentros
                ) &&

                centrosRedux
                    .resumenCentros
                    .length >
                    0
            )

        )

    );


const ultimoRefrescoResumenProcesadoRef =
    useRef(
        null
    );


useEffect(() => {

    /*
    Ya procesamos esta entrada.
    */

    if (
        ultimoRefrescoResumenProcesadoRef
            .current ===
        refrescoVersion
    ) {

        return;

    }


    if (
        !authToken ||
        !config ||
        centros.length ===
            0 ||
        !periodoValido
    ) {

        return;

    }


    const esPrimerProcesamiento =

        ultimoRefrescoResumenProcesadoRef
            .current ===
        null;


    /*
    Primera entrada y no había caché:
    no duplicamos la carga inicial.
    */

    if (
        esPrimerProcesamiento &&
        !habiaResumenAlMontarRef
            .current
    ) {

        ultimoRefrescoResumenProcesadoRef
            .current =
            refrescoVersion;


        return;

    }


    /*
    Marcamos antes del dispatch para
    impedir repeticiones por renders.
    */

    ultimoRefrescoResumenProcesadoRef
        .current =
        refrescoVersion;


    const refrescarResumen =
        async () => {


            /*
            ====================================
            RESUMEN GENERAL
            ====================================

            UNA request para TODOS los centros.
            ====================================
            */

            try {

                await dispatch(
                    cargarResumenCentrosAction({

                        config,

                        centros,

                        id_paciente:
                            idPacienteFiltro,

                        mes:
                            periodoConsulta
                                .mes ||
                            null,

                        fecha_desde:
                            periodoConsulta
                                .fecha_desde ||
                            null,

                        fecha_hasta:
                            periodoConsulta
                                .fecha_hasta ||
                            null,

                        moneda:
                            'ARS',

                        forzar:
                            true

                    })
                );

            } catch (
                errorResumen
            ) {

                // No bloqueamos la pantalla.

            }


            /*
            ====================================
            HISTORIAL DE PAGOS
            ====================================

            Sólo si ya había sido consultado.
            ====================================
            */

            if (
                historialPagosCentroCargado &&
                centroSeleccionadoId
            ) {

                try {

                    await dispatch(
                        cargarPagosCentroAction({

                            config,

                            centro_id:
                                centroSeleccionadoId,

                            moneda:
                                'ARS',

                            forzar:
                                true

                        })
                    );

                } catch (
                    errorPagos
                ) {

                    // No bloqueamos la pantalla.

                }

            }

        };


    refrescarResumen();

}, [
    refrescoVersion,
    authToken,
    config,
    dispatch,
    centros,
    idPacienteFiltro,
    periodoConsulta,
    periodoValido,
    historialPagosCentroCargado,
    centroSeleccionadoId
]);

/*
====================================
TOTALES DEL CENTRO SELECCIONADO
====================================

Estos son los valores que mostramos
en los KPIs principales.

Respetan:
- centro seleccionado;
- paciente seleccionado;
- período seleccionado.

No hacemos ninguna consulta nueva.
====================================
*/

const totalesCentroSeleccionado =
useMemo(() => {

const resumen =
liquidacion
?.resumen ||
{};


const debitos =
Number(
resumen
.debitos_generados_periodo ||
0
);


const creditos =
Number(
resumen
.creditos_generados_periodo ||
0
);


return {

corresponde:
debitos -
creditos,

pagado:
Number(
resumen
.pagado_sobre_obligaciones_periodo ||
0
),

pendiente:
Number(
resumen
.deuda_real_pendiente_periodo ||
0
),

esperandoCobro:
Number(
resumen
.estimado_esperando_cobro ||
0
)

};

}, [
liquidacion
]);

/*
====================================
PRESTACIONES
====================================
*/

const prestaciones =
Array.isArray(
liquidacion
?.detalle_prestaciones
)

? liquidacion
.detalle_prestaciones

: [];

/*
====================================
ESTIMADOS MENSUALES AL COBRO
====================================

FIJO_MENSUAL + MES_CON_COBROS
se calcula agrupado por paciente
y mes.

Por eso no viene dentro de una
prestación individual.
====================================
*/

const estimadosMensualesCobro =
Array.isArray(
liquidacion
?.detalle_estimados_mensuales_cobro
)

? liquidacion
.detalle_estimados_mensuales_cobro

: [];

const mensualesVinculados =

Array.isArray(
liquidacion
?.detalle_mensuales_vinculados
)

? liquidacion
.detalle_mensuales_vinculados

: [];

/*
====================================
RANGO REAL DEL PERÍODO
====================================
*/

const rangoPeriodoVisible =
useMemo(() => {

if (
periodoConsulta?.mes
) {

const [
year,
month
] =
periodoConsulta
.mes
.split('-')
.map(
Number
);


const ultimoDia =
new Date(
year,
month,
0
);


return {

fecha_desde:
`${periodoConsulta.mes}-01`,

fecha_hasta:
formatDateLocal(
ultimoDia
)

};

}


return {

fecha_desde:
periodoConsulta
?.fecha_desde ||
null,

fecha_hasta:
periodoConsulta
?.fecha_hasta ||
null

};

}, [
periodoConsulta
]);


/*
====================================
RESUMEN POR PACIENTE
====================================

La tabla combina:

- pacientes que tuvieron prestaciones;
- pacientes vinculados al centro aunque
tengan 0 prestaciones.

El filtro global de paciente también
se respeta.
====================================
*/

const resumenPacientesCentro =
useMemo(() => {

const mapa =
new Map();


const crearFila = (
idPaciente
) => ({

id_paciente:
String(
idPaciente
),

prestaciones:
[],

acuerdos:
[],

mensualesVinculados:
[],

vinculado:
false,

cantidad:
0,

cobradoPaciente:
0,

corresponde:
0,

pagadoCentro:
0,

pendienteCentro:
0,

esperandoCobro:
0

});


const obtenerFila = (
idPaciente
) => {

const id =
String(
idPaciente
);


if (
!mapa.has(
id
)
) {

mapa.set(
id,
crearFila(
id
)
);

}


return mapa.get(
id
);

};


/*
====================================
PRESTACIONES
====================================
*/

prestaciones.forEach(
(prestacion) => {

const idPaciente =
String(
prestacion
.id_paciente
);


if (
idPacienteFiltro &&
idPaciente !==
String(
idPacienteFiltro
)
) {

return;

}


const fila =
obtenerFila(
idPaciente
);


const debito =
Number(
prestacion
.fee_generado_debito ||
0
);


const credito =
Number(
prestacion
.fee_generado_credito ||
0
);


fila.prestaciones.push(
prestacion
);


fila.cantidad +=
1;


fila.cobradoPaciente +=
Number(
prestacion
.cobrado_paciente ||
0
);


fila.corresponde +=
debito -
credito;


fila.pagadoCentro +=
Number(
prestacion
.pagado_al_centro ||
0
);


fila.pendienteCentro +=
Number(
prestacion
.pendiente_centro ||
0
);


fila.esperandoCobro +=
Number(
prestacion
.estimado_esperando_cobro ||
0
);

}
);

/*
====================================
ESTIMADOS MENSUALES AL COBRO
====================================

Se agregan al paciente correspondiente
una sola vez por grupo mensual.

No los sumamos desde cada prestación
porque FIJO_MENSUAL + MES_CON_COBROS
es un concepto agrupado.
====================================
*/

estimadosMensualesCobro.forEach(
(estimado) => {

const idPaciente =
String(
estimado
.id_paciente
);


if (
idPacienteFiltro &&
idPaciente !==
String(
idPacienteFiltro
)
) {

return;

}


const fila =
obtenerFila(
idPaciente
);


fila.esperandoCobro +=
Number(
estimado
.importe_estimado ||
0
);

}
);

/*
====================================
MENSUALES POR VINCULACIÓN
====================================

No pertenecen a una prestación.

Se agregan directamente al resumen
económico del paciente.
====================================
*/

mensualesVinculados.forEach(
(mensual) => {

const idPaciente =
String(
mensual
.id_paciente
);


if (
idPacienteFiltro &&
idPaciente !==
String(
idPacienteFiltro
)
) {

return;

}


const fila =
obtenerFila(
idPaciente
);


fila
.mensualesVinculados
.push(
mensual
);


fila.corresponde +=
Number(
mensual
.corresponde_centro ||
0
);


fila.pagadoCentro +=
Number(
mensual
.pagado_al_centro ||
0
);


fila.pendienteCentro +=
Number(
mensual
.pendiente_centro ||
0
);

}
);

/*
====================================
ACUERDOS / VINCULACIONES
====================================
*/

acuerdosCentro.forEach(
(acuerdo) => {

if (
acuerdo?.activo ===
false
) {

return;

}


const fechaDesde =
String(
acuerdo
?.fecha_desde ||
''
)
.substring(
0,
10
);


const fechaHasta =
acuerdo
?.fecha_hasta

? String(
acuerdo
.fecha_hasta
)
.substring(
0,
10
)

: null;


const periodoDesde =
rangoPeriodoVisible
?.fecha_desde;


const periodoHasta =
rangoPeriodoVisible
?.fecha_hasta;


if (
!periodoDesde ||
!periodoHasta
) {

return;

}


const intersectaPeriodo =

fechaDesde <=
periodoHasta &&

(
!fechaHasta ||
fechaHasta >=
periodoDesde
);


if (
!intersectaPeriodo
) {

return;

}


const idPaciente =
String(
acuerdo
.id_paciente
);


if (
idPacienteFiltro &&
idPaciente !==
String(
idPacienteFiltro
)
) {

return;

}


const fila =
obtenerFila(
idPaciente
);


fila.vinculado =
true;


fila.acuerdos.push(
acuerdo
);

}
);


return Array
.from(
mapa.values()
)
.sort(
(
a,
b
) => {

const pacienteA =
pacientesPorId.get(
String(
a.id_paciente
)
);


const pacienteB =
pacientesPorId.get(
String(
b.id_paciente
)
);


const nombreA =
`${pacienteA?.apellido || ''}, ${pacienteA?.nombre || ''}`;


const nombreB =
`${pacienteB?.apellido || ''}, ${pacienteB?.nombre || ''}`;


return nombreA.localeCompare(
nombreB,
'es'
);

}
);

}, [
prestaciones,
estimadosMensualesCobro,
acuerdosCentro,
pacientesPorId,
idPacienteFiltro,
rangoPeriodoVisible,
mensualesVinculados
]);


/*
====================================
CANTIDAD DE PACIENTES
====================================
*/

const cantidadPacientesVinculados =
resumenPacientesCentro.filter(
(paciente) =>
paciente.vinculado
).length;


const cantidadPacientesConPrestaciones =
resumenPacientesCentro.filter(
(paciente) =>
paciente.cantidad > 0
).length;


/*
====================================
CREAR CENTRO
====================================
*/

const handleCrearCentro = async (
datos
) => {

if (
!config ||
guardandoCentro
) {

return false;

}


setGuardandoCentro(
true
);


try {

const resultado =
await dispatch(
crearCentroAction({

config,

datos

})
);


if (
resultado
?.centro
?.id
) {

setCentroSeleccionadoId(
String(
resultado
.centro
.id
)
);

}


/*
Cerramos primero el react-modal.

De esta manera SweetAlert queda
por encima correctamente.
*/

setModalCentroAbierto(
false
);


Swal.fire({

icon:
'success',

title:
'Centro creado',

text:
'El centro y su configuración económica fueron guardados correctamente.',

confirmButtonText:
'OK'

});


return true;


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

error.message ||

'No se pudo crear el centro.';


await Swal.fire({

icon:
'error',

title:
'No se pudo crear el centro',

text:
mensaje,

confirmButtonText:
'OK'

});


return false;


} finally {

setGuardandoCentro(
false
);

}

};


/*
====================================
DESPLEGAR PACIENTE
====================================
*/

const togglePacienteDesplegado = (
idPaciente
) => {

const id =
String(
idPaciente
);


setPacientesDesplegados(
(actuales) => {

if (
actuales.includes(
id
)
) {

return actuales.filter(
(item) =>
item !== id
);

}


return [
...actuales,
id
];

}
);

};


/*
====================================
VINCULAR PACIENTE
====================================
*/

const handleVincularPaciente = async (datos) => {
    if (!config || guardandoAcuerdoCentro) {
        return {
            ok: false,
            msg: 'No se puede vincular el paciente en este momento.'
        };
    }

    try {
        await dispatch(
            crearAcuerdoCentroAction({
                config,
                datos
            })
        );

        /*
        ====================================
        ACTUALIZAR LIQUIDACIÓN DEL CENTRO
        ====================================

        Vincular un paciente puede generar
        inmediatamente una obligación.

        Ejemplo:
        FIJO_MENSUAL + MES_VINCULADO.

        Después de crear el acuerdo consultamos
        una sola vez la liquidación del centro
        afectado.

        Esa misma respuesta actualiza:
        - resumen del centro;
        - posición global;
        - detalle por paciente;
        - caché.

        No hacemos un resumen masivo adicional.
        ====================================
        */

        try {
            await dispatch(
                cargarLiquidacionCentroAction({
                    config,
                    centro_id: datos.centro_id,
                    id_paciente: idPacienteFiltro,

                    mes:
                        periodoConsulta?.mes ||
                        null,

                    fecha_desde:
                        periodoConsulta?.fecha_desde ||
                        null,

                    fecha_hasta:
                        periodoConsulta?.fecha_hasta ||
                        null,

                    moneda: 'ARS',
                    incluir_detalle: true,
                    forzar: true
                })
            );
        } catch (errorLiquidacion) {
            /*
            El vínculo ya fue creado.

            Si falla solamente el refresh de la
            liquidación, no convertimos el guardado
            del vínculo en un falso error.
            */
        }

        /*
        Cerramos primero el modal para que
        SweetAlert no quede detrás.
        */

        setModalVincularPacienteAbierto(false);

        Swal.fire({
            icon: 'success',
            title: 'Paciente vinculado',
            text: 'El paciente quedó vinculado al centro correctamente.',
            confirmButtonText: 'OK'
        });

        return {
            ok: true
        };
    } catch (error) {
        const mensaje =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            error.message ||
            'No se pudo vincular el paciente al centro.';

        return {
            ok: false,
            msg: mensaje
        };
    }
};

/*
====================================
ACUERDO ABIERTO DEL PACIENTE
====================================
*/

const getAcuerdoAbiertoPaciente = (
idPaciente
) => {

return (

acuerdosCentro
.filter(
(acuerdo) =>

acuerdo
?.activo !==
false &&

String(
acuerdo
?.id_paciente
) ===
String(
idPaciente
) &&

String(
acuerdo
?.centro_id
) ===
String(
centroSeleccionadoId
) &&

!acuerdo
?.fecha_hasta
)
.sort(
(
a,
b
) =>

String(
b.fecha_desde
)
.localeCompare(
String(
a.fecha_desde
)
)
)[0] ||

null

);

};


/*
====================================
FINALIZAR VÍNCULO
====================================
*/

const handleFinalizarVinculo =
async (
pacienteFila,
acuerdo
) => {

if (
!acuerdo ||
cerrandoAcuerdoCentro
) {

return;

}


const fechaDesde =
String(
acuerdo
.fecha_desde
)
.substring(
0,
10
);


const hoy =
formatDateLocal(
new Date()
);


/*
Puede existir una versión futura.

En ese caso no podemos proponer hoy
porque fecha_hasta nunca puede quedar
antes de fecha_desde.
*/

const fechaSugerida =

hoy >=
fechaDesde

? hoy

: fechaDesde;


const nombrePaciente =
getNombrePaciente(
pacienteFila
.id_paciente
);


const resultado =
await Swal.fire({

icon:
'question',

title:
'Finalizar vínculo',

html:
`
<div
style="
text-align:left;
font-size:14px;
line-height:1.6;
"
>

<strong>
${nombrePaciente}
</strong>

<br>

${centroSeleccionado?.nombre || 'Centro'}

<br><br>

Indicá hasta qué fecha estuvo vigente la vinculación.

<br><br>

<input
id="fechaFinVinculo"
type="date"
min="${fechaDesde}"
value="${fechaSugerida}"
style="
width:100%;
box-sizing:border-box;
padding:10px 12px;
border:1px solid #d5dddd;
border-radius:8px;
font-size:14px;
outline:none;
"
/>

</div>
`,

showCancelButton:
true,

confirmButtonText:
'Finalizar vínculo',

cancelButtonText:
'Cancelar',

reverseButtons:
true,

focusConfirm:
false,

preConfirm: () => {

const inputFecha =
Swal.getPopup()
?.querySelector(
'#fechaFinVinculo'
);


const fecha =
inputFecha
?.value ||
'';


if (
!fecha
) {

Swal.showValidationMessage(
'Indicá la fecha de finalización.'
);


return false;

}


if (
fecha <
fechaDesde
) {

Swal.showValidationMessage(
`La fecha no puede ser anterior al ${formatDateDisplay(
fechaDesde
)}.`
);


return false;

}


return fecha;

}

});


if (
!resultado
.isConfirmed
) {

return;

}


try {

await dispatch(
cerrarAcuerdoCentroAction({

config,

centro_id:
centroSeleccionadoId,

acuerdo_id:
acuerdo.id,

fecha_hasta:
resultado.value

})
);


await Swal.fire({

icon:
'success',

title:
'Vínculo finalizado',

text:
'La fecha de finalización quedó registrada. El historial anterior se conserva.',

confirmButtonText:
'OK'

});


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

error.message ||

'No se pudo finalizar la vinculación del paciente.';


await Swal.fire({

icon:
'error',

title:
'No se pudo finalizar el vínculo',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};

/*
====================================
ABRIR CONDICIONES DEL PACIENTE
====================================
*/

const handleAbrirCondicionesPaciente = (
pacienteFila
) => {

const pacienteReal =
pacientesPorId.get(
String(
pacienteFila
.id_paciente
)
);


setPacienteCondicionesSeleccionado(

pacienteReal ||

{
id_paciente:
pacienteFila
.id_paciente
}

);


setModalCondicionesPacienteAbierto(
true
);

};


/*
====================================
GUARDAR CONDICIONES DEL PACIENTE
====================================
*/

const handleGuardarCondicionesPaciente =
async (
datos
) => {

if (
!config ||
guardandoCondicionesAcuerdoCentro
) {

return {

ok:
false,

msg:
'No se pueden guardar las condiciones en este momento.'

};

}


try {

await dispatch(
actualizarAcuerdoCentroAction({

config,

datos

})
);


/*
====================================
RECARGAR ACUERDOS
====================================

La nueva versión puede haber cerrado
una versión anterior.

Por eso acá preferimos consultar una
vez al backend y refrescar la caché.
====================================
*/

try {

await dispatch(
cargarAcuerdosCentroAction({

config,

centro_id:
datos.centro_id,

forzar:
true

})
);

} catch (
errorRecarga
) {

/*
La modificación ya fue guardada.

No convertimos un error de refresh
en un falso error de guardado.
*/

}


setModalCondicionesPacienteAbierto(
false
);


setPacienteCondicionesSeleccionado(
null
);


Swal.fire({

icon:
'success',

title:
'Condiciones actualizadas',

text:
'La nueva condición del paciente quedó guardada con su vigencia correspondiente.',

confirmButtonText:
'OK'

});


return {
ok:
true
};


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

error.message ||

'No se pudieron actualizar las condiciones del paciente.';


return {

ok:
false,

msg:
mensaje

};

}

};

/*
====================================
ABRIR CONFIGURACIÓN DEL CENTRO
====================================
*/

const handleAbrirConfiguracionCentro =
async () => {

if (
!config ||
!centroSeleccionadoId
) {

return;

}


try {

await dispatch(
cargarConfiguracionesCentroAction({

config,

centro_id:
centroSeleccionadoId

})
);


setModalConfiguracionCentroAbierto(
true
);


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.message ||

'No se pudieron cargar las condiciones generales del centro.';


await Swal.fire({

icon:
'error',

title:
'No se pudieron cargar las condiciones',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};


/*
====================================
GUARDAR CONFIGURACIÓN DEL CENTRO
====================================
*/

const handleGuardarConfiguracionCentro =
async (
datos
) => {

if (
!config ||
guardandoConfiguracionCentro
) {

return {

ok:
false,

msg:
'No se puede guardar la configuración en este momento.'

};

}


try {

await dispatch(
crearConfiguracionCentroAction({

config,

datos

})
);


/*
Refrescamos el historial porque
el backend también puede haber
cerrado la versión anterior.
*/

try {

await dispatch(
cargarConfiguracionesCentroAction({

config,

centro_id:
datos.centro_id,

forzar:
true

})
);

} catch (
errorConfiguraciones
) {

// El guardado ya fue realizado.

}


/*
Refrescamos centros para que,
si la nueva versión empieza hoy,
centro.configuracion quede actualizado.
*/

try {

await dispatch(
cargarCentrosAction({

config,

forzar:
true

})
);

} catch (
errorCentros
) {

// El guardado ya fue realizado.

}


setModalConfiguracionCentroAbierto(
false
);


await Swal.fire({

icon:
'success',

title:
'Condiciones actualizadas',

text:
'La nueva configuración general quedó guardada sin modificar el historial anterior.',

confirmButtonText:
'OK'

});


return {
ok:
true
};


} catch (error) {

const mensaje =

error.response
?.data
?.msg ||

error.response
?.data
?.message ||

error.message ||

'No se pudo guardar la nueva configuración del centro.';


return {

ok:
false,

msg:
mensaje

};

}

};

/*
====================================
ABRIR HISTORIAL DE PAGOS
====================================
*/

const handleAbrirHistorialPagosCentro =
async () => {

if (
!config ||
!centroSeleccionadoId
) {

return;

}


setModalHistorialPagosCentroAbierto(
true
);


try {

await dispatch(
cargarPagosCentroAction({

config,

centro_id:
centroSeleccionadoId,

moneda:
'ARS'

})
);


} catch (error) {

setModalHistorialPagosCentroAbierto(
false
);


const mensaje =

error.response
?.data
?.msg ||

error.message ||

'No se pudo cargar el historial de pagos.';


await Swal.fire({

icon:
'error',

title:
'No se pudo cargar el historial',

text:
mensaje,

confirmButtonText:
'OK'

});

}

};


/*
====================================
ANULAR PAGO DEL CENTRO
====================================
*/

const handleAnularPagoCentro = async (datos) => {

    if (
        !config ||
        anulandoPagoCentro
    ) {

        return {
            ok: false,
            msg: 'No se puede anular el pago en este momento.'
        };

    }


    try {

        await dispatch(
            anularPagoCentroAction({
                config,
                centro_id: centroSeleccionadoId,
                moneda: 'ARS',
                pago_centro_id: datos.pago_centro_id,
                motivo_anulacion: datos.motivo_anulacion
            })
        );


        /*
        ====================================
        ACTUALIZAR CENTRO MODIFICADO
        ====================================

        Una única liquidación detallada
        actualiza:

        - detalle;
        - KPIs;
        - posición global;
        - fila del resumen.
        ====================================
        */

        try {

            await dispatch(
                cargarLiquidacionCentroAction({
                    config,
                    centro_id: centroSeleccionadoId,
                    id_paciente: idPacienteFiltro,
                    mes: periodoConsulta.mes || null,
                    fecha_desde: periodoConsulta.fecha_desde || null,
                    fecha_hasta: periodoConsulta.fecha_hasta || null,
                    moneda: 'ARS',
                    incluir_detalle: true,
                    forzar: true
                })
            );

        } catch (errorLiquidacion) {

            // La anulación ya fue realizada.

        }


        return {
            ok: true
        };


    } catch (error) {

        const mensaje =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            error.message ||
            'No se pudo anular el pago.';


        return {
            ok: false,
            msg: mensaje
        };

    }

};


/*
====================================
REGISTRAR PAGO AL CENTRO
====================================
*/

const handleRegistrarPagoCentro = async (datos) => {

    if (
        !config ||
        registrandoPagoCentro
    ) {

        return {
            ok: false,
            msg: 'No se puede registrar el pago en este momento.'
        };

    }


    try {

        const resultado =
            await dispatch(
                registrarPagoCentroAction({
                    config,
                    datos
                })
            );


        /*
        ====================================
        ACTUALIZAR CENTRO MODIFICADO
        ====================================

        La liquidación individual ya devuelve
        también posicion_actual.

        No hacemos una consulta separada de
        posición ni un resumen masivo.
        ====================================
        */

        try {

            await dispatch(
                cargarLiquidacionCentroAction({
                    config,
                    centro_id: datos.centro_id,
                    id_paciente: idPacienteFiltro,
                    mes: periodoConsulta.mes || null,
                    fecha_desde: periodoConsulta.fecha_desde || null,
                    fecha_hasta: periodoConsulta.fecha_hasta || null,
                    moneda: 'ARS',
                    incluir_detalle: true,
                    forzar: true
                })
            );

        } catch (errorLiquidacion) {

            // El pago ya fue registrado.

        }


        setModalPagoCentroAbierto(
            false
        );


        const saldoDisponible =
            Number(
                resultado?.saldo_disponible || 0
            );


        await Swal.fire({
            icon: 'success',
            title: 'Pago registrado',
            text:
                saldoDisponible > 0
                    ? `El pago fue registrado. Quedaron ${formatMoney(
                        saldoDisponible
                    )} disponibles para aplicar a futuras obligaciones.`
                    : 'El pago al centro quedó registrado correctamente.',
            confirmButtonText: 'OK'
        });


        return {
            ok: true
        };


    } catch (error) {

        const mensaje =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            error.message ||
            'No se pudo registrar el pago al centro.';


        return {
            ok: false,
            msg: mensaje
        };

    }

};


/*
====================================
CAMBIAR PAGAR / NO PAGAR
DE UNA PRESTACIÓN
====================================
*/

const handleCambiarCondicionPrestacion = async (
    prestacion
) => {

    if (
        !config ||
        !prestacion?.centro_prestacion_id ||
        guardandoCondicionPrestacionCentro
    ) {

        return;

    }


    const usaOverride =
        prestacion.pagar_override !== null &&
        prestacion.pagar_override !== undefined;


    const valorActual =
        !usaOverride
            ? 'ORIGINAL'
            : prestacion.pagar_override
                ? 'PAGAR'
                : 'NO_PAGAR';


    const reglaOriginal =
        prestacion.pagar_regla_snapshot
            ? 'Pagar'
            : 'No pagar';


    const resultado =
        await Swal.fire({

            title:
                'Condición de la prestación',

            html: `
                <div
                    style="
                        text-align:left;
                        font-size:14px;
                    "
                >

                    <div
                        style="
                            margin-bottom:14px;
                            color:#586565;
                        "
                    >
                        ${formatDateDisplay(
                            prestacion.fecha_prestacion
                        )}
                        ·
                        ${getTipoPrestacionLabel(
                            prestacion.tipo_prestacion
                        )}
                    </div>


                    <label
                        for="condicionPrestacionCentro"
                        style="
                            display:block;
                            margin-bottom:6px;
                            font-size:12px;
                            font-weight:700;
                            color:#657272;
                            text-transform:uppercase;
                        "
                    >
                        Condición
                    </label>


                    <select
                        id="condicionPrestacionCentro"
                        style="
                            width:100%;
                            box-sizing:border-box;
                            padding:10px 12px;
                            border:1px solid #D5DDDD;
                            border-radius:8px;
                            font-size:14px;
                            background:white;
                            margin-bottom:16px;
                        "
                    >

                        <option
                            value="ORIGINAL"
                            ${
                                valorActual === 'ORIGINAL'
                                    ? 'selected'
                                    : ''
                            }
                        >
                            Usar condición original (${reglaOriginal})
                        </option>

                        <option
                            value="PAGAR"
                            ${
                                valorActual === 'PAGAR'
                                    ? 'selected'
                                    : ''
                            }
                        >
                            Pagar esta prestación
                        </option>

                        <option
                            value="NO_PAGAR"
                            ${
                                valorActual === 'NO_PAGAR'
                                    ? 'selected'
                                    : ''
                            }
                        >
                            No pagar esta prestación
                        </option>

                    </select>


                    <label
                        for="observacionPrestacionCentro"
                        style="
                            display:block;
                            margin-bottom:6px;
                            font-size:12px;
                            font-weight:700;
                            color:#657272;
                            text-transform:uppercase;
                        "
                    >
                        Observación
                    </label>


                    <textarea
                        id="observacionPrestacionCentro"
                        maxlength="500"
                        placeholder="Opcional"
                        style="
                            width:100%;
                            min-height:80px;
                            box-sizing:border-box;
                            padding:10px 12px;
                            border:1px solid #D5DDDD;
                            border-radius:8px;
                            font-size:14px;
                            resize:vertical;
                        "
                    ></textarea>

                </div>
            `,

            showCancelButton:
                true,

            confirmButtonText:
                'Guardar',

            cancelButtonText:
                'Cancelar',

            reverseButtons:
                true,

            focusConfirm:
                false,

            preConfirm: () => {

                const select =
                    Swal.getPopup()
                        ?.querySelector(
                            '#condicionPrestacionCentro'
                        );


                const textarea =
                    Swal.getPopup()
                        ?.querySelector(
                            '#observacionPrestacionCentro'
                        );


                const valor =
                    select?.value;


                let pagarOverride =
                    null;


                if (
                    valor === 'PAGAR'
                ) {

                    pagarOverride =
                        true;

                }


                if (
                    valor === 'NO_PAGAR'
                ) {

                    pagarOverride =
                        false;

                }


                return {
                    pagar_override:
                        pagarOverride,

                    observacion:
                        textarea?.value?.trim() || null
                };

            }

        });


    if (
        !resultado.isConfirmed
    ) {

        return;

    }


    try {

        await dispatch(
            cambiarPagarPrestacionCentroAction({
                config,
                centro_prestacion_id:
                    prestacion.centro_prestacion_id,
                pagar_override:
                    resultado.value.pagar_override,
                observacion:
                    resultado.value.observacion
            })
        );


        /*
        ====================================
        ACTUALIZAR CENTRO MODIFICADO
        ====================================

        Una sola liquidación detallada
        actualiza todo lo visible.
        ====================================
        */

        try {

            await dispatch(
                cargarLiquidacionCentroAction({
                    config,
                    centro_id:
                        centroSeleccionadoId,
                    id_paciente:
                        idPacienteFiltro,
                    mes:
                        periodoConsulta.mes || null,
                    fecha_desde:
                        periodoConsulta.fecha_desde || null,
                    fecha_hasta:
                        periodoConsulta.fecha_hasta || null,
                    moneda:
                        'ARS',
                    incluir_detalle:
                        true,
                    forzar:
                        true
                })
            );

        } catch (errorLiquidacion) {

            // El cambio ya fue realizado.

        }


        /*
        ====================================
        HISTORIAL DE PAGOS
        ====================================

        Sólo lo refrescamos si ya había
        sido consultado.

        El cambio de PAGAR / NO PAGAR
        puede modificar imputaciones.
        ====================================
        */

        if (
            historialPagosCentroCargado
        ) {

            try {

                await dispatch(
                    cargarPagosCentroAction({
                        config,
                        centro_id:
                            centroSeleccionadoId,
                        moneda:
                            'ARS',
                        forzar:
                            true
                    })
                );

            } catch (errorPagos) {

                // El cambio ya fue realizado.

            }

        }


        await Swal.fire({
            icon:
                'success',

            title:
                'Condición actualizada',

            text:
                'La condición de esta prestación quedó actualizada correctamente.',

            confirmButtonText:
                'OK'
        });


    } catch (error) {

        const mensaje =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            error.message ||
            'No se pudo actualizar la condición de la prestación.';


        await Swal.fire({
            icon:
                'error',

            title:
                'No se pudo actualizar',

            text:
                mensaje,

            confirmButtonText:
                'OK'
        });

    }

};

/*
====================================
RENDER
====================================
*/

return (
    <EstadisticasMain>
        {
            cargandoCentros &&
            centros.length === 0

                ? (
                    <CargandoEstadisticas>
                        Cargando centros...
                    </CargandoEstadisticas>
                )

                : centros.length === 0

                    ? (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '1rem',
                                paddingTop: '1rem'
                            }}
                        >
                            <SinInformacion>
                                Todavía no hay centros cargados.
                            </SinInformacion>

                            <BotonPrincipal
                                type="button"
                                onClick={() =>
                                    setModalCentroAbierto(
                                        true
                                    )
                                }
                            >
                                + Agregar centro
                            </BotonPrincipal>
                        </div>
                    )

                    : (
                        <>
                            {/*
                            ====================================
                            CENTRO + PACIENTE
                            ====================================
                            */}

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    gap: '0.75rem',
                                    flexWrap: 'wrap',
                                    marginBottom: '0.75rem'
                                }}
                            >
                                {/*
                                ====================================
                                CENTRO
                                ====================================
                                */}

                                <div
                                    style={{
                                        width: '320px',
                                        maxWidth: '100%'
                                    }}
                                >
                                    <div
                                        style={{
                                            marginBottom: '0.3rem',
                                            fontSize: '0.65rem',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            color: '#737F7F'
                                        }}
                                    >
                                        Centro
                                    </div>

                                    <CobroSelect
                                        value={
                                            centroSeleccionadoId
                                        }
                                        onChange={(e) =>
                                            setCentroSeleccionadoId(
                                                e.target.value
                                            )
                                        }
                                    >
                                        {
                                            centros.map(
                                                (centro) => (
                                                    <option
                                                        key={
                                                            centro.id
                                                        }
                                                        value={
                                                            centro.id
                                                        }
                                                    >
                                                        {
                                                            centro.nombre
                                                        }

                                                        {
                                                            centro.activo === false
                                                                ? ' (inactivo)'
                                                                : ''
                                                        }
                                                    </option>
                                                )
                                            )
                                        }
                                    </CobroSelect>
                                </div>

                                {/*
                                ====================================
                                PACIENTE
                                ====================================
                                */}

                                <div
                                    style={{
                                        width: '320px',
                                        maxWidth: '100%'
                                    }}
                                >
                                    <div
                                        style={{
                                            marginBottom: '0.3rem',
                                            fontSize: '0.65rem',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            color: '#737F7F'
                                        }}
                                    >
                                        Paciente
                                    </div>

                                    <CobroSelect
                                        value={
                                            idPacienteSeleccionadoCentro
                                        }
                                        onChange={(e) =>
                                            setIdPacienteSeleccionadoCentro(
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="TODOS">
                                            Todos los pacientes
                                        </option>

                                        {
                                            [
                                                ...pacientes
                                            ]
                                                .sort(
                                                    (
                                                        pacienteA,
                                                        pacienteB
                                                    ) => {

                                                        const nombreA =
                                                            `${pacienteA.apellido || ''}, ${pacienteA.nombre || ''}`
                                                                .replace(
                                                                    /^,\s*/,
                                                                    ''
                                                                )
                                                                .trim();

                                                        const nombreB =
                                                            `${pacienteB.apellido || ''}, ${pacienteB.nombre || ''}`
                                                                .replace(
                                                                    /^,\s*/,
                                                                    ''
                                                                )
                                                                .trim();

                                                        return nombreA.localeCompare(
                                                            nombreB,
                                                            'es'
                                                        );
                                                    }
                                                )
                                                .map(
                                                    (paciente) => {

                                                        const nombre =
                                                            `${paciente.apellido || ''}, ${paciente.nombre || ''}`
                                                                .replace(
                                                                    /^,\s*/,
                                                                    ''
                                                                )
                                                                .trim();

                                                        return (
                                                            <option
                                                                key={
                                                                    paciente.id_paciente
                                                                }
                                                                value={
                                                                    paciente.id_paciente
                                                                }
                                                            >
                                                                {
                                                                    nombre ||
                                                                    'Paciente sin nombre'
                                                                }
                                                            </option>
                                                        );
                                                    }
                                                )
                                        }
                                    </CobroSelect>
                                </div>

                                {/*
                                ====================================
                                CONFIGURACIÓN DEL CENTRO
                                ====================================
                                */}

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <div
                                        style={{
                                            marginBottom: '0.3rem',
                                            fontSize: '0.65rem',
                                            fontWeight: 700,
                                            textTransform: 'uppercase',
                                            color: '#737F7F'
                                        }}
                                    >
                                        Configuración
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.6rem',
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <BotonSecundario
                                            type="button"
                                            onClick={
                                                handleAbrirConfiguracionCentro
                                            }
                                            disabled={
                                                !centroSeleccionado ||
                                                cargandoConfiguracionesCentro
                                            }
                                        >
                                            {
                                                cargandoConfiguracionesCentro
                                                    ? 'Cargando...'
                                                    : 'Condiciones generales'
                                            }
                                        </BotonSecundario>

                                        <BotonPrincipal
                                            type="button"
                                            onClick={() =>
                                                setModalCentroAbierto(
                                                    true
                                                )
                                            }
                                        >
                                            + Agregar centro
                                        </BotonPrincipal>
                                    </div>
                                </div>
                            </div>

                            {/*
                            ====================================
                            PERÍODO
                            ====================================
                            */}

                            <ContenedorFiltros>
                                <GrupoPeriodos>
                                    <BotonPeriodo
                                        $activo={
                                            tipoPeriodo ===
                                            'MES_ACTUAL'
                                        }
                                        onClick={() =>
                                            setTipoPeriodo(
                                                'MES_ACTUAL'
                                            )
                                        }
                                    >
                                        Este mes
                                    </BotonPeriodo>

                                    <BotonPeriodo
                                        $activo={
                                            tipoPeriodo ===
                                            'MES_ANTERIOR'
                                        }
                                        onClick={() =>
                                            setTipoPeriodo(
                                                'MES_ANTERIOR'
                                            )
                                        }
                                    >
                                        Mes anterior
                                    </BotonPeriodo>

                                    <BotonPeriodo
                                        $activo={
                                            tipoPeriodo ===
                                            'ANIO_ACTUAL'
                                        }
                                        onClick={() =>
                                            setTipoPeriodo(
                                                'ANIO_ACTUAL'
                                            )
                                        }
                                    >
                                        Este año
                                    </BotonPeriodo>

                                    <BotonPeriodo
                                        $activo={
                                            tipoPeriodo ===
                                            'PERSONALIZADO'
                                        }
                                        onClick={() =>
                                            setTipoPeriodo(
                                                'PERSONALIZADO'
                                            )
                                        }
                                    >
                                        Personalizado
                                    </BotonPeriodo>
                                </GrupoPeriodos>

                                {
                                    tipoPeriodo ===
                                    'PERSONALIZADO'

                                        ? (
                                            <FechasPersonalizadas>
                                                <FechaPersonalizadaGrupo>
                                                    <FechaPersonalizadaLabel>
                                                        Desde
                                                    </FechaPersonalizadaLabel>

                                                    <FechaPersonalizadaInput
                                                        type="date"
                                                        value={
                                                            fechaDesdePersonalizada
                                                        }
                                                        max={
                                                            fechaHastaPersonalizada ||
                                                            undefined
                                                        }
                                                        onChange={(e) =>
                                                            setFechaDesdePersonalizada(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </FechaPersonalizadaGrupo>

                                                <FechaPersonalizadaGrupo>
                                                    <FechaPersonalizadaLabel>
                                                        Hasta
                                                    </FechaPersonalizadaLabel>

                                                    <FechaPersonalizadaInput
                                                        type="date"
                                                        value={
                                                            fechaHastaPersonalizada
                                                        }
                                                        min={
                                                            fechaDesdePersonalizada ||
                                                            undefined
                                                        }
                                                        onChange={(e) =>
                                                            setFechaHastaPersonalizada(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </FechaPersonalizadaGrupo>
                                            </FechasPersonalizadas>
                                        )

                                        : null
                                }

                                <PeriodoTexto>
                                    {periodoTexto}
                                </PeriodoTexto>
                            </ContenedorFiltros>

                            {
                                cargandoResumen &&
                                resumenCentros.length === 0

                                    ? (
                                        <CargandoEstadisticas>
                                            Cargando información...
                                        </CargandoEstadisticas>
                                    )

                                    : (
                                        <>
                                            {/*
                                            ====================================
                                            KPIS
                                            ====================================
                                            */}

                                            <GridKpis>
                                                <TarjetaKpi
                                                    $color="#655EE8"
                                                >
                                                    <KpiTitulo>
                                                        Corresponde al centro
                                                    </KpiTitulo>

                                                    <KpiValor>
                                                        {
                                                            formatMoney(
                                                                totalesCentroSeleccionado
                                                                    .corresponde
                                                            )
                                                        }
                                                    </KpiValor>

                                                    <KpiDetalle>
                                                        Débitos menos créditos
                                                        del período
                                                    </KpiDetalle>
                                                </TarjetaKpi>

                                                <TarjetaKpi
                                                    $color="#23AAAF"
                                                >
                                                    <KpiTitulo>
                                                        Pagado al centro
                                                    </KpiTitulo>

                                                    <KpiValor>
                                                        {
                                                            formatMoney(
                                                                totalesCentroSeleccionado
                                                                    .pagado
                                                            )
                                                        }
                                                    </KpiValor>

                                                    <KpiDetalle>
                                                        aplicado sobre obligaciones
                                                        del período
                                                    </KpiDetalle>
                                                </TarjetaKpi>

                                                <TarjetaKpi
                                                    $color="#D76970"
                                                >
                                                    <KpiTitulo>
                                                        Pendiente al centro
                                                    </KpiTitulo>

                                                    <KpiValor>
                                                        {
                                                            formatMoney(
                                                                totalesCentroSeleccionado
                                                                    .pendiente
                                                            )
                                                        }
                                                    </KpiValor>

                                                    <KpiDetalle>
                                                        obligación neta pendiente
                                                    </KpiDetalle>
                                                </TarjetaKpi>

                                                <TarjetaKpi
                                                    $color="#EFC340"
                                                >
                                                    <KpiTitulo>
                                                        Esperando cobro
                                                    </KpiTitulo>

                                                    <KpiValor>
                                                        {
                                                            formatMoney(
                                                                totalesCentroSeleccionado
                                                                    .esperandoCobro
                                                            )
                                                        }
                                                    </KpiValor>

                                                    <KpiDetalle>
                                                        todavía no genera obligación
                                                    </KpiDetalle>
                                                </TarjetaKpi>
                                            </GridKpis>

                                            {/*
                                            ====================================
                                            POSICIÓN GLOBAL DEL CENTRO
                                            ====================================
                                            */}

                                            <div
                                                style={{
                                                    marginTop: '0.85rem',
                                                    marginBottom: '0.85rem',
                                                    padding: '0.9rem 1rem',
                                                    border: '1px solid #DCE5E5',
                                                    borderRadius: '12px',
                                                    backgroundColor: '#FAFCFC',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    gap: '1rem',
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <div>
                                                    <div
                                                        style={{
                                                            fontWeight: 700,
                                                            fontSize: '0.88rem',
                                                            marginBottom: '0.2rem'
                                                        }}
                                                    >
                                                        Posición de {
                                                            centroSeleccionado
                                                                ?.nombre ||
                                                            'centro'
                                                        }
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: '0.68rem',
                                                            color: '#6B7777'
                                                        }}
                                                    >
                                                        Posición global, independiente
                                                        del período y del paciente seleccionado.
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '1.5rem',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <div>
                                                        <div
                                                            style={{
                                                                fontSize: '0.62rem',
                                                                color: '#6B7777',
                                                                textTransform: 'uppercase'
                                                            }}
                                                        >
                                                            Pendiente neto
                                                        </div>

                                                        <strong>
                                                            {
                                                                cargandoPosicionCentro &&
                                                                !posicionCentro

                                                                    ? '...'

                                                                    : formatMoney(
                                                                        posicionCentro
                                                                            ?.saldo_neto_pendiente
                                                                    )
                                                            }
                                                        </strong>
                                                    </div>

                                                    <div>
                                                        <div
                                                            style={{
                                                                fontSize: '0.62rem',
                                                                color: '#6B7777',
                                                                textTransform: 'uppercase'
                                                            }}
                                                        >
                                                            Saldo a favor
                                                        </div>

                                                        <strong>
                                                            {
                                                                formatMoney(
                                                                    posicionCentro
                                                                        ?.saldo_a_favor
                                                                )
                                                            }
                                                        </strong>
                                                    </div>

                                                    <div>
                                                        <div
                                                            style={{
                                                                fontSize: '0.62rem',
                                                                color: '#6B7777',
                                                                textTransform: 'uppercase'
                                                            }}
                                                        >
                                                            Pagos sin aplicar
                                                        </div>

                                                        <strong>
                                                            {
                                                                formatMoney(
                                                                    posicionCentro
                                                                        ?.pagos_sin_aplicar
                                                                )
                                                            }
                                                        </strong>
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '0.6rem',
                                                        alignItems: 'center',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <BotonSecundario
                                                        type="button"
                                                        onClick={
                                                            handleAbrirHistorialPagosCentro
                                                        }
                                                        disabled={
                                                            !centroSeleccionado ||
                                                            cargandoPagosCentro
                                                        }
                                                    >
                                                        {
                                                            cargandoPagosCentro
                                                                ? 'Cargando...'
                                                                : 'Historial de pagos'
                                                        }
                                                    </BotonSecundario>

                                                    <BotonPrincipal
                                                        type="button"
                                                        onClick={() =>
                                                            setModalPagoCentroAbierto(
                                                                true
                                                            )
                                                        }
                                                        disabled={
                                                            !centroSeleccionado ||
                                                            registrandoPagoCentro
                                                        }
                                                    >
                                                        + Registrar pago
                                                    </BotonPrincipal>
                                                </div>
                                            </div>

                                            {/*
                                            ====================================
                                            RESUMEN POR CENTRO
                                            ====================================
                                            */}

                                            <SeccionTitulo>
                                                <SeccionTituloPrincipal>
                                                    Resumen por centro
                                                </SeccionTituloPrincipal>

                                                <SeccionTituloSecundario>
                                                    Seleccioná un centro para
                                                    ver debajo el detalle
                                                    agrupado por paciente.
                                                </SeccionTituloSecundario>
                                            </SeccionTitulo>

                                            <TablaContenedor>
                                                {
                                                    resumenCentros.length === 0

                                                        ? (
                                                            <SinInformacion>
                                                                No hay información
                                                                de centros para el
                                                                período seleccionado.
                                                            </SinInformacion>
                                                        )

                                                        : (
                                                            <TablaTurnos>
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Centro
                                                                        </th>

                                                                        <th>
                                                                            Corresponde
                                                                        </th>

                                                                        <th>
                                                                            Pagado
                                                                        </th>

                                                                        <th>
                                                                            Pendiente
                                                                        </th>

                                                                        <th>
                                                                            Esperando cobro
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {
                                                                        resumenCentros.map(
                                                                            (
                                                                                item
                                                                            ) => {

                                                                                const centro =
                                                                                    item.centro;

                                                                                const resumen =
                                                                                    item
                                                                                        ?.liquidacion
                                                                                        ?.resumen ||
                                                                                    {};

                                                                                const corresponde =
                                                                                    Number(
                                                                                        resumen
                                                                                            .debitos_generados_periodo ||
                                                                                        0
                                                                                    ) -
                                                                                    Number(
                                                                                        resumen
                                                                                            .creditos_generados_periodo ||
                                                                                        0
                                                                                    );

                                                                                const pagado =
                                                                                    Number(
                                                                                        resumen
                                                                                            .pagado_sobre_obligaciones_periodo ||
                                                                                        0
                                                                                    );

                                                                                const pendiente =
                                                                                    Number(
                                                                                        resumen
                                                                                            .deuda_real_pendiente_periodo ||
                                                                                        0
                                                                                    );

                                                                                const esperando =
                                                                                    Number(
                                                                                        resumen
                                                                                            .estimado_esperando_cobro ||
                                                                                        0
                                                                                    );

                                                                                const seleccionado =
                                                                                    String(
                                                                                        centro.id
                                                                                    ) ===
                                                                                    String(
                                                                                        centroSeleccionadoId
                                                                                    );

                                                                                return (
                                                                                    <tr
                                                                                        key={
                                                                                            centro.id
                                                                                        }
                                                                                        onClick={() =>
                                                                                            setCentroSeleccionadoId(
                                                                                                String(
                                                                                                    centro.id
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        onKeyDown={(e) => {

                                                                                            if (
                                                                                                e.key ===
                                                                                                'Enter' ||
                                                                                                e.key ===
                                                                                                ' '
                                                                                            ) {

                                                                                                e.preventDefault();

                                                                                                setCentroSeleccionadoId(
                                                                                                    String(
                                                                                                        centro.id
                                                                                                    )
                                                                                                );
                                                                                            }

                                                                                        }}
                                                                                        role="button"
                                                                                        tabIndex={
                                                                                            0
                                                                                        }
                                                                                        style={{
                                                                                            cursor: 'pointer',
                                                                                            backgroundColor:
                                                                                                seleccionado
                                                                                                    ? '#F0FAFA'
                                                                                                    : undefined
                                                                                        }}
                                                                                    >
                                                                                        <td>
                                                                                            <strong>
                                                                                                {
                                                                                                    centro.nombre
                                                                                                }
                                                                                            </strong>
                                                                                        </td>

                                                                                        <td>
                                                                                            <Importe>
                                                                                                {
                                                                                                    formatMoney(
                                                                                                        corresponde
                                                                                                    )
                                                                                                }
                                                                                            </Importe>
                                                                                        </td>

                                                                                        <td>
                                                                                            <Importe>
                                                                                                {
                                                                                                    formatMoney(
                                                                                                        pagado
                                                                                                    )
                                                                                                }
                                                                                            </Importe>
                                                                                        </td>

                                                                                        <td>
                                                                                            <Importe>
                                                                                                {
                                                                                                    formatMoney(
                                                                                                        pendiente
                                                                                                    )
                                                                                                }
                                                                                            </Importe>
                                                                                        </td>

                                                                                        <td>
                                                                                            <Importe>
                                                                                                {
                                                                                                    formatMoney(
                                                                                                        esperando
                                                                                                    )
                                                                                                }
                                                                                            </Importe>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </TablaTurnos>
                                                        )
                                                }
                                            </TablaContenedor>

                                            {/*
                                            ====================================
                                            PACIENTES DEL CENTRO
                                            ====================================
                                            */}

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    justifyContent: 'space-between',
                                                    gap: '1rem',
                                                    flexWrap: 'wrap'
                                                }}
                                            >
                                                <SeccionTitulo>
                                                    <SeccionTituloPrincipal>
                                                        Pacientes de {
                                                            centroSeleccionado
                                                                ?.nombre ||
                                                            'Centro'
                                                        }
                                                    </SeccionTituloPrincipal>

                                                    <SeccionTituloSecundario>
                                                        {
                                                            cantidadPacientesVinculados
                                                        } {
                                                            cantidadPacientesVinculados ===
                                                            1

                                                                ? 'paciente vinculado'

                                                                : 'pacientes vinculados'
                                                        } · {
                                                            cantidadPacientesConPrestaciones
                                                        } con prestaciones en el período seleccionado.
                                                    </SeccionTituloSecundario>
                                                </SeccionTitulo>

                                                <BotonPrincipal
                                                    type="button"
                                                    onClick={() =>
                                                        setModalVincularPacienteAbierto(
                                                            true
                                                        )
                                                    }
                                                    disabled={
                                                        !centroSeleccionado ||
                                                        centroSeleccionado
                                                            ?.activo ===
                                                        false
                                                    }
                                                >
                                                    + Vincular paciente
                                                </BotonPrincipal>
                                            </div>

                                            <TablaContenedor>
                                                {
                                                    resumenPacientesCentro.length ===
                                                    0

                                                        ? (
                                                            <SinInformacion>
                                                                No hay pacientes vinculados
                                                                ni prestaciones para este centro
                                                                en el período seleccionado.
                                                            </SinInformacion>
                                                        )

                                                        : (
                                                            <TablaTurnos>
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Paciente
                                                                        </th>

                                                                        <th>
                                                                            Condición
                                                                        </th>

                                                                        <th>
                                                                            Prestaciones
                                                                        </th>

                                                                        <th>
                                                                            Cobrado paciente
                                                                        </th>

                                                                        <th>
                                                                            Corresponde centro
                                                                        </th>

                                                                        <th>
                                                                            Pagado centro
                                                                        </th>

                                                                        <th>
                                                                            Pendiente centro
                                                                        </th>

                                                                        <th>
                                                                            Esperando cobro
                                                                        </th>

                                                                        <th>
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    {
                                                                        resumenPacientesCentro.map(
                                                                            (
                                                                                paciente
                                                                            ) => {

                                                                                const desplegado =
                                                                                    pacientesDesplegados
                                                                                        .includes(
                                                                                            String(
                                                                                                paciente
                                                                                                    .id_paciente
                                                                                            )
                                                                                        );

                                                                                const condicion =
                                                                                    getTipoCondicionPaciente(
                                                                                        paciente.acuerdos
                                                                                    );

                                                                                const tienePrestaciones =
                                                                                    paciente.cantidad >
                                                                                    0;

                                                                                const tieneMensualesVinculados =
                                                                                    Array.isArray(
                                                                                        paciente
                                                                                            .mensualesVinculados
                                                                                    ) &&
                                                                                    paciente
                                                                                        .mensualesVinculados
                                                                                        .length >
                                                                                    0;

                                                                                /*
                                                                                ====================================
                                                                                DETALLE DISPONIBLE
                                                                                ====================================

                                                                                Puede existir detalle por:

                                                                                - prestaciones;
                                                                                - mensualidades generadas solamente
                                                                                  por estar vinculado al centro.

                                                                                De esta forma un paciente con
                                                                                FIJO_MENSUAL + MES_VINCULADO puede
                                                                                desplegarse aunque tenga 0
                                                                                prestaciones.
                                                                                ====================================
                                                                                */

                                                                                const tieneDetalle =
                                                                                    tienePrestaciones ||
                                                                                    tieneMensualesVinculados;

                                                                                const acuerdoAbierto =
                                                                                    getAcuerdoAbiertoPaciente(
                                                                                        paciente.id_paciente
                                                                                    );

                                                                                return (
                                                                                    <React.Fragment
                                                                                        key={
                                                                                            paciente
                                                                                                .id_paciente
                                                                                        }
                                                                                    >
                                                                                        {/*
                                                                                        ====================================
                                                                                        RESUMEN DEL PACIENTE
                                                                                        ====================================
                                                                                        */}

                                                                                        <tr
                                                                                            role={
                                                                                                tieneDetalle
                                                                                                    ? 'button'
                                                                                                    : undefined
                                                                                            }
                                                                                            tabIndex={
                                                                                                tieneDetalle
                                                                                                    ? 0
                                                                                                    : -1
                                                                                            }
                                                                                            onClick={() => {

                                                                                                if (
                                                                                                    !tieneDetalle
                                                                                                ) {

                                                                                                    return;
                                                                                                }

                                                                                                togglePacienteDesplegado(
                                                                                                    paciente
                                                                                                        .id_paciente
                                                                                                );
                                                                                            }}
                                                                                            onKeyDown={(e) => {

                                                                                                if (
                                                                                                    !tieneDetalle
                                                                                                ) {

                                                                                                    return;
                                                                                                }

                                                                                                if (
                                                                                                    e.key ===
                                                                                                    'Enter' ||
                                                                                                    e.key ===
                                                                                                    ' '
                                                                                                ) {

                                                                                                    e.preventDefault();

                                                                                                    togglePacienteDesplegado(
                                                                                                        paciente
                                                                                                            .id_paciente
                                                                                                    );
                                                                                                }

                                                                                            }}
                                                                                            style={{
                                                                                                cursor:
                                                                                                    tieneDetalle
                                                                                                        ? 'pointer'
                                                                                                        : 'default',

                                                                                                backgroundColor:
                                                                                                    desplegado &&
                                                                                                    tieneDetalle

                                                                                                        ? '#F7FBFB'

                                                                                                        : undefined
                                                                                            }}
                                                                                        >
                                                                                            <td>
                                                                                                <strong>
                                                                                                    {
                                                                                                        getNombrePaciente(
                                                                                                            paciente
                                                                                                                .id_paciente
                                                                                                        )
                                                                                                    }
                                                                                                </strong>
                                                                                            </td>

                                                                                            <td>
                                                                                                <div
                                                                                                    style={{
                                                                                                        display: 'flex',
                                                                                                        alignItems: 'center',
                                                                                                        gap: '0.5rem',
                                                                                                        flexWrap: 'wrap'
                                                                                                    }}
                                                                                                >
                                                                                                    <span
                                                                                                        style={{
                                                                                                            display: 'inline-flex',
                                                                                                            alignItems: 'center',
                                                                                                            padding: '0.22rem 0.5rem',
                                                                                                            borderRadius: '999px',
                                                                                                            fontSize: '0.65rem',
                                                                                                            fontWeight: 700,

                                                                                                            backgroundColor:
                                                                                                                condicion.tipo ===
                                                                                                                'PARTICULAR'

                                                                                                                    ? '#FFF5D9'

                                                                                                                    : condicion.tipo ===
                                                                                                                    'MIXTA'

                                                                                                                        ? '#F4EEFF'

                                                                                                                        : '#EAF7F7',

                                                                                                            color:
                                                                                                                condicion.tipo ===
                                                                                                                'PARTICULAR'

                                                                                                                    ? '#92720A'

                                                                                                                    : condicion.tipo ===
                                                                                                                    'MIXTA'

                                                                                                                        ? '#655EE8'

                                                                                                                        : '#18898D'
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            condicion.texto
                                                                                                        }
                                                                                                    </span>

                                                                                                    {
                                                                                                        paciente.vinculado

                                                                                                            ? (
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    onClick={(e) => {

                                                                                                                        e.stopPropagation();

                                                                                                                        handleAbrirCondicionesPaciente(
                                                                                                                            paciente
                                                                                                                        );
                                                                                                                    }}
                                                                                                                    style={{
                                                                                                                        border: 'none',
                                                                                                                        background: 'transparent',
                                                                                                                        padding: 0,
                                                                                                                        cursor: 'pointer',
                                                                                                                        fontSize: '0.68rem',
                                                                                                                        fontWeight: 700,
                                                                                                                        color: '#18898D',
                                                                                                                        textDecoration: 'underline'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Configurar
                                                                                                                </button>
                                                                                                            )

                                                                                                            : null
                                                                                                    }

                                                                                                    {
                                                                                                        acuerdoAbierto

                                                                                                            ? (
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    onClick={(e) => {

                                                                                                                        e.stopPropagation();

                                                                                                                        handleFinalizarVinculo(
                                                                                                                            paciente,
                                                                                                                            acuerdoAbierto
                                                                                                                        );
                                                                                                                    }}
                                                                                                                    disabled={
                                                                                                                        cerrandoAcuerdoCentro
                                                                                                                    }
                                                                                                                    style={{
                                                                                                                        border: 'none',
                                                                                                                        background: 'transparent',
                                                                                                                        padding: 0,

                                                                                                                        cursor:
                                                                                                                            cerrandoAcuerdoCentro
                                                                                                                                ? 'default'
                                                                                                                                : 'pointer',

                                                                                                                        fontSize: '0.68rem',
                                                                                                                        fontWeight: 700,
                                                                                                                        color: '#C45B63',
                                                                                                                        textDecoration: 'underline'
                                                                                                                    }}
                                                                                                                >
                                                                                                                    Finalizar vínculo
                                                                                                                </button>
                                                                                                            )

                                                                                                            : null
                                                                                                    }
                                                                                                </div>
                                                                                            </td>

                                                                                            <td>
                                                                                                {
                                                                                                    paciente
                                                                                                        .cantidad
                                                                                                }
                                                                                            </td>

                                                                                            <td>
                                                                                                <Importe>
                                                                                                    {
                                                                                                        formatMoney(
                                                                                                            paciente
                                                                                                                .cobradoPaciente
                                                                                                        )
                                                                                                    }
                                                                                                </Importe>
                                                                                            </td>

                                                                                            <td>
                                                                                                <Importe>
                                                                                                    {
                                                                                                        formatMoney(
                                                                                                            paciente
                                                                                                                .corresponde
                                                                                                        )
                                                                                                    }
                                                                                                </Importe>
                                                                                            </td>

                                                                                            <td>
                                                                                                <Importe>
                                                                                                    {
                                                                                                        formatMoney(
                                                                                                            paciente
                                                                                                                .pagadoCentro
                                                                                                        )
                                                                                                    }
                                                                                                </Importe>
                                                                                            </td>

                                                                                            <td>
                                                                                                <Importe>
                                                                                                    {
                                                                                                        formatMoney(
                                                                                                            paciente
                                                                                                                .pendienteCentro
                                                                                                        )
                                                                                                    }
                                                                                                </Importe>
                                                                                            </td>

                                                                                            <td>
                                                                                                <Importe>
                                                                                                    {
                                                                                                        formatMoney(
                                                                                                            paciente
                                                                                                                .esperandoCobro
                                                                                                        )
                                                                                                    }
                                                                                                </Importe>
                                                                                            </td>

                                                                                            <td
                                                                                                style={{
                                                                                                    width: '34px',
                                                                                                    textAlign: 'center',
                                                                                                    fontSize: '1rem',
                                                                                                    fontWeight: 700,
                                                                                                    color: '#18898D'
                                                                                                }}
                                                                                            >
                                                                                                {
                                                                                                    tieneDetalle

                                                                                                        ? (
                                                                                                            desplegado
                                                                                                                ? '⌃'
                                                                                                                : '⌄'
                                                                                                        )

                                                                                                        : null
                                                                                                }
                                                                                            </td>
                                                                                        </tr>

                                                                                        {/*
                                                                                        ====================================
                                                                                        DETALLE DEL PACIENTE
                                                                                        ====================================
                                                                                        */}

                                                                                        {
                                                                                            desplegado &&
                                                                                            tieneDetalle

                                                                                                ? (
                                                                                                    <tr>
                                                                                                        <td
                                                                                                            colSpan={
                                                                                                                9
                                                                                                            }
                                                                                                            style={{
                                                                                                                padding: 0,
                                                                                                                backgroundColor: '#FAFCFC'
                                                                                                            }}
                                                                                                        >
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    padding: '0.8rem 1rem 1rem 2rem'
                                                                                                                }}
                                                                                                            >
                                                                                                                {/*
                                                                                                                ====================================
                                                                                                                MENSUALES POR VINCULACIÓN
                                                                                                                ====================================
                                                                                                                */}

                                                                                                                {
                                                                                                                    tieneMensualesVinculados

                                                                                                                        ? (
                                                                                                                            <>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        marginBottom: '0.55rem',
                                                                                                                                        fontSize: '0.68rem',
                                                                                                                                        fontWeight: 700,
                                                                                                                                        color: '#737F7F',
                                                                                                                                        textTransform: 'uppercase'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    Detalle de mensualidades
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        overflowX: 'auto'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <TablaTurnos>
                                                                                                                                        <thead>
                                                                                                                                            <tr>
                                                                                                                                                <th>
                                                                                                                                                    Mes
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Vencimiento
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Concepto
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Fee
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Corresponde centro
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Pagado centro
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Pendiente
                                                                                                                                                </th>
                                                                                                                                            </tr>
                                                                                                                                        </thead>

                                                                                                                                        <tbody>
                                                                                                                                            {
                                                                                                                                                paciente
                                                                                                                                                    .mensualesVinculados
                                                                                                                                                    .map(
                                                                                                                                                        (
                                                                                                                                                            mensual,
                                                                                                                                                            index
                                                                                                                                                        ) => {

                                                                                                                                                            const mesReferencia =
                                                                                                                                                                String(
                                                                                                                                                                    mensual
                                                                                                                                                                        .mes_referencia ||
                                                                                                                                                                    ''
                                                                                                                                                                );

                                                                                                                                                            const anioReferencia =
                                                                                                                                                                mesReferencia.substring(
                                                                                                                                                                    0,
                                                                                                                                                                    4
                                                                                                                                                                );

                                                                                                                                                            const numeroMes =
                                                                                                                                                                mesReferencia.substring(
                                                                                                                                                                    5,
                                                                                                                                                                    7
                                                                                                                                                                );

                                                                                                                                                            const mesMostrar =
                                                                                                                                                                anioReferencia &&
                                                                                                                                                                numeroMes

                                                                                                                                                                    ? `${numeroMes}/${anioReferencia}`

                                                                                                                                                                    : '—';

                                                                                                                                                            return (
                                                                                                                                                                <tr
                                                                                                                                                                    key={
                                                                                                                                                                        `mensual-${mensual.id_paciente}-${mensual.mes_referencia}-${index}`
                                                                                                                                                                    }
                                                                                                                                                                >
                                                                                                                                                                    <td>
                                                                                                                                                                        <strong>
                                                                                                                                                                            {
                                                                                                                                                                                mesMostrar
                                                                                                                                                                            }
                                                                                                                                                                        </strong>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        {
                                                                                                                                                                            mensual
                                                                                                                                                                                .fecha_vencimiento

                                                                                                                                                                                ? formatDateDisplay(
                                                                                                                                                                                    mensual
                                                                                                                                                                                        .fecha_vencimiento
                                                                                                                                                                                )

                                                                                                                                                                                : '—'
                                                                                                                                                                        }
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        Mensual por vinculación
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        {
                                                                                                                                                                            getFeeLabel(
                                                                                                                                                                                mensual
                                                                                                                                                                            )
                                                                                                                                                                        }
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    mensual
                                                                                                                                                                                        .corresponde_centro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    mensual
                                                                                                                                                                                        .pagado_al_centro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    mensual
                                                                                                                                                                                        .pendiente_centro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>
                                                                                                                                                                </tr>
                                                                                                                                                            );
                                                                                                                                                        }
                                                                                                                                                    )
                                                                                                                                            }
                                                                                                                                        </tbody>
                                                                                                                                    </TablaTurnos>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        )

                                                                                                                        : null
                                                                                                                }

                                                                                                                {/*
                                                                                                                ====================================
                                                                                                                DETALLE DE PRESTACIONES
                                                                                                                ====================================
                                                                                                                */}

                                                                                                                {
                                                                                                                    tienePrestaciones

                                                                                                                        ? (
                                                                                                                            <>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        marginTop:
                                                                                                                                            tieneMensualesVinculados
                                                                                                                                                ? '1rem'
                                                                                                                                                : 0,

                                                                                                                                        marginBottom: '0.55rem',
                                                                                                                                        fontSize: '0.68rem',
                                                                                                                                        fontWeight: 700,
                                                                                                                                        color: '#737F7F',
                                                                                                                                        textTransform: 'uppercase'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    Detalle de prestaciones
                                                                                                                                </div>

                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        overflowX: 'auto'
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <TablaTurnos>
                                                                                                                                        <thead>
                                                                                                                                            <tr>
                                                                                                                                                <th>
                                                                                                                                                    Fecha
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Vencimiento
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Tipo
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Condición
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Fee
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Importe prestación
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Cobrado paciente
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Corresponde centro
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Pagado centro
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Pendiente
                                                                                                                                                </th>

                                                                                                                                                <th>
                                                                                                                                                    Esperando cobro
                                                                                                                                                </th>
                                                                                                                                            </tr>
                                                                                                                                        </thead>

                                                                                                                                        <tbody>
                                                                                                                                            {
                                                                                                                                                paciente
                                                                                                                                                    .prestaciones
                                                                                                                                                    .map(
                                                                                                                                                        (
                                                                                                                                                            prestacion
                                                                                                                                                        ) => {

                                                                                                                                                            const correspondePrestacion =
                                                                                                                                                                Number(
                                                                                                                                                                    prestacion
                                                                                                                                                                        .fee_generado_debito ||
                                                                                                                                                                    0
                                                                                                                                                                ) -
                                                                                                                                                                Number(
                                                                                                                                                                    prestacion
                                                                                                                                                                        .fee_generado_credito ||
                                                                                                                                                                    0
                                                                                                                                                                );

                                                                                                                                                            /*
                                                                                                                                                            ====================================
                                                                                                                                                            VISUALIZACIÓN FIJO MENSUAL
                                                                                                                                                            ====================================

                                                                                                                                                            Un fijo mensual corresponde una sola
                                                                                                                                                            vez por paciente y mes.

                                                                                                                                                            La primera prestación que efectivamente
                                                                                                                                                            paga funciona como fila representativa.

                                                                                                                                                            Las demás se muestran como incluidas
                                                                                                                                                            en la mensualidad, independientemente
                                                                                                                                                            de si la obligación está actualmente
                                                                                                                                                            generada, compensada o esperando cobro.
                                                                                                                                                            ====================================
                                                                                                                                                            */

                                                                                                                                                            const esFijoMensual =
                                                                                                                                                                prestacion
                                                                                                                                                                    .fee_tipo ===
                                                                                                                                                                'FIJO_MENSUAL';

                                                                                                                                                            const mesPrestacion =
                                                                                                                                                                String(
                                                                                                                                                                    prestacion
                                                                                                                                                                        .fecha_prestacion ||
                                                                                                                                                                    ''
                                                                                                                                                                ).substring(
                                                                                                                                                                    0,
                                                                                                                                                                    7
                                                                                                                                                                );

                                                                                                                                                            const prestacionesMismoMensual =
                                                                                                                                                                esFijoMensual

                                                                                                                                                                    ? paciente
                                                                                                                                                                        .prestaciones
                                                                                                                                                                        .filter(
                                                                                                                                                                            (
                                                                                                                                                                                otraPrestacion
                                                                                                                                                                            ) => {

                                                                                                                                                                                const otroMes =
                                                                                                                                                                                    String(
                                                                                                                                                                                        otraPrestacion
                                                                                                                                                                                            .fecha_prestacion ||
                                                                                                                                                                                        ''
                                                                                                                                                                                    ).substring(
                                                                                                                                                                                        0,
                                                                                                                                                                                        7
                                                                                                                                                                                    );

                                                                                                                                                                                return (
                                                                                                                                                                                    otraPrestacion
                                                                                                                                                                                        .fee_tipo ===
                                                                                                                                                                                    'FIJO_MENSUAL' &&

                                                                                                                                                                                    otraPrestacion
                                                                                                                                                                                        .fee_mensual_condicion ===
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .fee_mensual_condicion &&

                                                                                                                                                                                    otroMes ===
                                                                                                                                                                                    mesPrestacion &&

                                                                                                                                                                                    otraPrestacion
                                                                                                                                                                                        .pagar_efectivo ===
                                                                                                                                                                                    true
                                                                                                                                                                                );
                                                                                                                                                                            }
                                                                                                                                                                        )
                                                                                                                                                                        .sort(
                                                                                                                                                                            (
                                                                                                                                                                                a,
                                                                                                                                                                                b
                                                                                                                                                                            ) => {

                                                                                                                                                                                const fechaA =
                                                                                                                                                                                    String(
                                                                                                                                                                                        a
                                                                                                                                                                                            .fecha_prestacion ||
                                                                                                                                                                                        ''
                                                                                                                                                                                    );

                                                                                                                                                                                const fechaB =
                                                                                                                                                                                    String(
                                                                                                                                                                                        b
                                                                                                                                                                                            .fecha_prestacion ||
                                                                                                                                                                                        ''
                                                                                                                                                                                    );

                                                                                                                                                                                if (
                                                                                                                                                                                    fechaA !==
                                                                                                                                                                                    fechaB
                                                                                                                                                                                ) {

                                                                                                                                                                                    return fechaA.localeCompare(
                                                                                                                                                                                        fechaB
                                                                                                                                                                                    );
                                                                                                                                                                                }

                                                                                                                                                                                return (
                                                                                                                                                                                    Number(
                                                                                                                                                                                        a
                                                                                                                                                                                            .centro_prestacion_id ||
                                                                                                                                                                                        0
                                                                                                                                                                                    ) -

                                                                                                                                                                                    Number(
                                                                                                                                                                                        b
                                                                                                                                                                                            .centro_prestacion_id ||
                                                                                                                                                                                        0
                                                                                                                                                                                    )
                                                                                                                                                                                );
                                                                                                                                                                            }
                                                                                                                                                                        )

                                                                                                                                                                    : [];

                                                                                                                                                            const prestacionRepresentanteMensual =
                                                                                                                                                                prestacionesMismoMensual[
                                                                                                                                                                    0
                                                                                                                                                                ] ||
                                                                                                                                                                null;

                                                                                                                                                            const incluidaEnMensualidad =
                                                                                                                                                                esFijoMensual &&

                                                                                                                                                                prestacionRepresentanteMensual &&

                                                                                                                                                                String(
                                                                                                                                                                    prestacionRepresentanteMensual
                                                                                                                                                                        .centro_prestacion_id
                                                                                                                                                                ) !==

                                                                                                                                                                String(
                                                                                                                                                                    prestacion
                                                                                                                                                                        .centro_prestacion_id
                                                                                                                                                                );

                                                                                                                                                            return (
                                                                                                                                                                <tr
                                                                                                                                                                    key={
                                                                                                                                                                        prestacion
                                                                                                                                                                            .centro_prestacion_id
                                                                                                                                                                    }
                                                                                                                                                                >
                                                                                                                                                                    <td>
                                                                                                                                                                        <strong>
                                                                                                                                                                            {
                                                                                                                                                                                formatDateDisplay(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .fecha_prestacion
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </strong>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        {
                                                                                                                                                                            prestacion
                                                                                                                                                                                .fecha_vencimiento

                                                                                                                                                                                ? formatDateDisplay(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .fecha_vencimiento
                                                                                                                                                                                )

                                                                                                                                                                                : '—'
                                                                                                                                                                        }
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        {
                                                                                                                                                                            getTipoPrestacionLabel(
                                                                                                                                                                                prestacion
                                                                                                                                                                                    .tipo_prestacion
                                                                                                                                                                            )
                                                                                                                                                                        }
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <div
                                                                                                                                                                            style={{
                                                                                                                                                                                display: 'flex',
                                                                                                                                                                                alignItems: 'center',
                                                                                                                                                                                gap: '0.45rem',
                                                                                                                                                                                flexWrap: 'wrap'
                                                                                                                                                                            }}
                                                                                                                                                                        >
                                                                                                                                                                            <EstadoBadge
                                                                                                                                                                                $tipo={
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .pagar_efectivo

                                                                                                                                                                                        ? 'COBRADO'

                                                                                                                                                                                        : 'NO_COBRABLE'
                                                                                                                                                                                }
                                                                                                                                                                            >
                                                                                                                                                                                {
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .pagar_efectivo

                                                                                                                                                                                        ? 'Pagar'

                                                                                                                                                                                        : 'No pagar'
                                                                                                                                                                                }
                                                                                                                                                                            </EstadoBadge>

                                                                                                                                                                            {
                                                                                                                                                                                prestacion
                                                                                                                                                                                    .pagar_override !==
                                                                                                                                                                                null &&

                                                                                                                                                                                prestacion
                                                                                                                                                                                    .pagar_override !==
                                                                                                                                                                                undefined

                                                                                                                                                                                    ? (
                                                                                                                                                                                        <span
                                                                                                                                                                                            style={{
                                                                                                                                                                                                fontSize: '0.62rem',
                                                                                                                                                                                                fontWeight: 700,
                                                                                                                                                                                                color: '#92720A',
                                                                                                                                                                                                backgroundColor: '#FFF5D9',
                                                                                                                                                                                                padding: '0.18rem 0.4rem',
                                                                                                                                                                                                borderRadius: '999px'
                                                                                                                                                                                            }}
                                                                                                                                                                                        >
                                                                                                                                                                                            Particular
                                                                                                                                                                                        </span>
                                                                                                                                                                                    )

                                                                                                                                                                                    : null
                                                                                                                                                                            }

                                                                                                                                                                            <button
                                                                                                                                                                                type="button"
                                                                                                                                                                                onClick={(e) => {

                                                                                                                                                                                    e.stopPropagation();

                                                                                                                                                                                    handleCambiarCondicionPrestacion(
                                                                                                                                                                                        prestacion
                                                                                                                                                                                    );
                                                                                                                                                                                }}
                                                                                                                                                                                disabled={
                                                                                                                                                                                    guardandoCondicionPrestacionCentro
                                                                                                                                                                                }
                                                                                                                                                                                style={{
                                                                                                                                                                                    border: 'none',
                                                                                                                                                                                    background: 'transparent',
                                                                                                                                                                                    padding: 0,

                                                                                                                                                                                    cursor:
                                                                                                                                                                                        guardandoCondicionPrestacionCentro
                                                                                                                                                                                            ? 'default'
                                                                                                                                                                                            : 'pointer',

                                                                                                                                                                                    fontSize: '0.68rem',
                                                                                                                                                                                    fontWeight: 700,
                                                                                                                                                                                    color: '#18898D',
                                                                                                                                                                                    textDecoration: 'underline'
                                                                                                                                                                                }}
                                                                                                                                                                            >
                                                                                                                                                                                Configurar
                                                                                                                                                                            </button>
                                                                                                                                                                        </div>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        {
                                                                                                                                                                            incluidaEnMensualidad

                                                                                                                                                                                ? (
                                                                                                                                                                                    <span
                                                                                                                                                                                        style={{
                                                                                                                                                                                            fontSize: '0.72rem',
                                                                                                                                                                                            color: '#738080',
                                                                                                                                                                                            fontStyle: 'italic'
                                                                                                                                                                                        }}
                                                                                                                                                                                    >
                                                                                                                                                                                        Incluida en mensualidad
                                                                                                                                                                                    </span>
                                                                                                                                                                                )

                                                                                                                                                                                : getFeeLabel(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                )
                                                                                                                                                                        }
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .importe_cargo
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .cobrado_paciente
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    correspondePrestacion
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .pagado_al_centro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .pendiente_centro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>

                                                                                                                                                                    <td>
                                                                                                                                                                        <Importe>
                                                                                                                                                                            {
                                                                                                                                                                                formatMoney(
                                                                                                                                                                                    prestacion
                                                                                                                                                                                        .estimado_esperando_cobro
                                                                                                                                                                                )
                                                                                                                                                                            }
                                                                                                                                                                        </Importe>
                                                                                                                                                                    </td>
                                                                                                                                                                </tr>
                                                                                                                                                            );
                                                                                                                                                        }
                                                                                                                                                    )
                                                                                                                                            }
                                                                                                                                        </tbody>
                                                                                                                                    </TablaTurnos>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        )

                                                                                                                        : null
                                                                                                                }
                                                                                                            </div>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                )

                                                                                                : null
                                                                                        }
                                                                                    </React.Fragment>
                                                                                );
                                                                            }
                                                                        )
                                                                    }
                                                                </tbody>
                                                            </TablaTurnos>
                                                        )
                                                }
                                            </TablaContenedor>
                                        </>
                                    )
                            }
                        </>
                    )
        }

        <HistorialPagosCentroModal
            isOpen={
                modalHistorialPagosCentroAbierto
            }
            onClose={() =>
                setModalHistorialPagosCentroAbierto(
                    false
                )
            }
            centro={
                centroSeleccionado
            }
            pagos={
                pagosCentro
            }
            cargando={
                cargandoPagosCentro
            }
            anulando={
                anulandoPagoCentro
            }
            onAnular={
                handleAnularPagoCentro
            }
        />

        <PagoCentroModal
            isOpen={
                modalPagoCentroAbierto
            }
            onClose={() =>
                setModalPagoCentroAbierto(
                    false
                )
            }
            centro={
                centroSeleccionado
            }
            posicion={
                posicionCentro
            }
            onGuardar={
                handleRegistrarPagoCentro
            }
            guardando={
                registrandoPagoCentro
            }
        />

        <ConfiguracionCentroModal
            isOpen={
                modalConfiguracionCentroAbierto
            }
            onClose={() =>
                setModalConfiguracionCentroAbierto(
                    false
                )
            }
            centro={
                centroSeleccionado
            }
            configuraciones={
                configuracionesCentro
            }
            onGuardar={
                handleGuardarConfiguracionCentro
            }
            guardando={
                guardandoConfiguracionCentro
            }
        />

        <CondicionesPacienteCentroModal
            isOpen={
                modalCondicionesPacienteAbierto
            }
            onClose={() => {

                setModalCondicionesPacienteAbierto(
                    false
                );

                setPacienteCondicionesSeleccionado(
                    null
                );
            }}
            centro={
                centroSeleccionado
            }
            paciente={
                pacienteCondicionesSeleccionado
            }
            acuerdos={
                acuerdosCentro
            }
            onGuardar={
                handleGuardarCondicionesPaciente
            }
            guardando={
                guardandoCondicionesAcuerdoCentro
            }
        />

        <VincularPacienteCentroModal
            isOpen={
                modalVincularPacienteAbierto
            }
            onClose={() =>
                setModalVincularPacienteAbierto(
                    false
                )
            }
            centro={
                centroSeleccionado
            }
            pacientes={
                pacientes
            }
            acuerdos={
                acuerdosCentro
            }
            onGuardar={
                handleVincularPaciente
            }
            guardando={
                guardandoAcuerdoCentro
            }
        />

        <CentroModal
            isOpen={
                modalCentroAbierto
            }
            onClose={() =>
                setModalCentroAbierto(
                    false
                )
            }
            onGuardar={
                handleCrearCentro
            }
            guardando={
                guardandoCentro
            }
        />
    </EstadisticasMain>
);

};


export default CentrosLiquidaciones;